import { useLogisticaConfiguration, withLogisticaConfiguration } from "../logistica/configurazione/LogisticaConfigurationProvider";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import {
  Calendar,
  Database,
  FileText,
  Globe2,
  Hash,
  Image,
  Layers,
  Package,
  Payments,
  Tags,
  User,
  Users,
} from "../interfaccia/advancedSearch/advancedSearchIcons";
import CategorieWebSub from "../modificaProdotti/moduliArticolo/CategorieWebSub";
import { buildMongoArticoliFiltersConfig } from "./mongoArticoliFiltersConfig";
import {
  MODA_ARTICOLI_COSTI_PERMISSION,
  PREZZI_FILTER_FIELDS,
  PREZZI_FILTER_LABELS,
  withoutPrezziRiservati,
} from "./prezziFiltersConfig";
import {
  CODICI_INCOLLATI_DEFAULT_TIPO,
  CODICI_INCOLLATI_MAX,
  CODICI_INCOLLATI_MAX_PARAM_LENGTH,
  CODICI_INCOLLATI_TIPI,
  describeCodiciIncollati,
  getCodiciIncollatiTipo,
  isCodiciIncollatiTroppoLungo,
  normalizeCodiciIncollatiFilters,
  parseCodiciIncollati,
} from "./codiciIncollatiConfig";
import UserAvatarBadge from "./UserAvatarBadge";
import {
  AdvancedSearchField,
  AdvancedSearchFieldRow,
  AdvancedSearchLayout,
  AdvancedSearchSelect,
  AdvancedSearchTextInput,
  AdvancedSearchValuePicker,
  isAdvancedSearchValueActive,
} from "../interfaccia/advancedSearch/AdvancedSearchLayout";

const buildDefaultFilters = () => ({
  codiciIncollati: "",
  codiciIncollatiTipo: "",
  codiceVS: "",
  idPs: "",
  nome: "",
  codiceProduttore: "",
  stato: "",
  colore: "",
  aggiornatoDa: "",
  aggiornatoA: "",
  importatoDa: "",
  importatoA: "",
  importRegistrato: "",
  pubblicatoDa: "",
  pubblicatoA: "",
  immaginiCreateDa: "",
  immaginiCreateA: "",
  brand: "",
  brand_in: [],
  brand_not_in: [],
  persona: "",
  persona_in: [],
  persona_not_in: [],
  reparto: "",
  reparto_in: [],
  reparto_not_in: [],
  categoria: "",
  categoria_in: [],
  categoria_not_in: [],
  tipo: "",
  tipo_in: [],
  tipo_not_in: [],
  sottotipo: "",
  sottotipo_in: [],
  sottotipo_not_in: [],
  stagione: "",
  stagione_in: [],
  stagione_not_in: [],
  tagModa_in: [],
  tagModa_not_in: [],
  annullato: "",
  troppeVarianti: "",
  ha_immagine: "",
  imm_nonsitrova: "",
  ut_import_done: "",
  ut_pubbl_done: "",
  ut_pubbl_pren: "",
  ut_imm_done: "",
  ut_imm_pren: "",
  ut_richiede: "",
  priorityMin: "",
  priorityMax: "",
  stockMin: "",
  stockMax: "",
  stockModaMin: "",
  stockModaMax: "",
  prezzoCartellinoMin: "",
  prezzoCartellinoMax: "",
  prezzoScontatoMin: "",
  prezzoScontatoMax: "",
  scontoPercentualeMin: "",
  scontoPercentualeMax: "",
  costoAcquistoMedioMin: "",
  costoAcquistoMedioMax: "",
  margineCartellinoMin: "",
  margineCartellinoMax: "",
  margineScontatoMin: "",
  margineScontatoMax: "",
  pubblicato: "",
  visibility: "",
  f_467_attivo_ecom: "",
  deactivation_reason: "",
  testi_importati: "",
  botTextConsolidationStatus: "",
  botImageConsolidationStatus: "",
  botSnapshotCategory_in: [],
  botSnapshotCategory_not_in: [],
  botSnapshotHasImage: "",
  vsArticoliGruppo: "",
  mostra_import_bot: "",
  mostra_export_vig: "",
  destinazioni_in: [],
  destinazioni_not_in: [],
  assignedTo: "",
  mongoFilters: {},
});

const BOOLEAN_OPTIONS = [
  { value: "", label: "Tutti" },
  { value: "1", label: "Si" },
  { value: "0", label: "No" },
];

const PUBBLICATO_OPTIONS = [
  { value: "", label: "Tutti" },
  { value: "SI", label: "SI" },
  { value: "DA CONTROLLARE", label: "DA CONTROLLARE" },
  { value: "NO", label: "NO" },
  { value: "PROBLEMA", label: "PROBLEMA" },
  { value: "NON PUBBLICARE", label: "NON PUBBLICARE" },
];

const BOT_CONSOLIDATION_OPTIONS = [
  { value: "", label: "Tutti" },
  { value: "NOT_ANALYZED", label: "Mai analizzato" },
  { value: "PENDING", label: "Da consolidare" },
  { value: "PARTIAL", label: "Parziale" },
  { value: "CONSOLIDATED", label: "Consolidato" },
  { value: "BLOCKED", label: "Bloccato" },
  { value: "ERROR", label: "Errore" },
  { value: "NOT_APPLICABLE", label: "Non applicabile" },
];

const VS_ARTICOLI_GRUPPO_OPTIONS = [
  { value: "", label: "Tutti" },
  { value: "ADHOC", label: "ADHOC" },
  { value: "BOTTI", label: "BOTTI" },
  { value: "VIGLI", label: "VIGLI" },
  { value: "XLS", label: "XLS" },
];

const VISIBILITY_OPTIONS = [
  { value: "", label: "Tutte" },
  { value: "both", label: "Both" },
  { value: "catalog", label: "Catalog" },
  { value: "search", label: "Search" },
  { value: "none", label: "None" },
];

const DEFAULT_CATEGORY_MAPPING_OUTPUTS = { VIG: [], BOT: [] };
const DEFAULT_SITE_CATEGORIES = { VIG: [], BOT: [] };
const CATEGORY_MAPPING_SITES = [
  { key: "VIG", label: "vigliettisport.com" },
  { key: "BOT", label: "botteroski.com" },
];

const PUBLICATION_DESTINATION_OPTIONS = [
  { code: "VIG", description: "vigliettisport.com" },
  { code: "BOT", description: "botteroski.com" },
];

const SQL_NOT_IN_TOOLTIP =
  "Per i filtri SQL in NOT IN vengono restituiti solo gli articoli con campo valorizzato.";

const TAG_MODA_NOT_IN_TOOLTIP =
  "NOT IN restituisce gli articoli che non hanno nessuno dei tag selezionati, compresi quelli senza alcun tag Moda.";

const TAG_MODA_FIELD = { key: "tagModa", label: "Tag Moda" };

const PUBLICATION_DESTINATION_NOT_IN_TOOLTIP =
  "NOT IN esclude gli articoli destinati ad almeno uno dei siti selezionati.";

const MONGO_NOT_IN_TOOLTIP =
  "Per i filtri pubblicazione, NOT IN include anche articoli mai pubblicati o con campo non valorizzato.";

const LOOKUP_FILTERS = [
  { key: "reparto", label: "Reparto", icon: Layers },
  { key: "categoria", label: "Categoria", icon: Tags },
  { key: "tipo", label: "Tipo", icon: Package },
  { key: "sottotipo", label: "Sottotipo", icon: Package },
  { key: "brand", label: "Brand", icon: Tags },
  { key: "persona", label: "Persona", icon: User },
  { key: "stagione", label: "Stagione", icon: Calendar },
];

const CATEGORY_VALUE_FILTERS_BY_SITE = {
  VIG: [
  {
    key: "categoriaPredefinita",
    label: "Categoria predefinita",
    includeKey: "categoriaPredefinita_in",
    icon: Globe2,
    help: "La categoria predefinita dell'articolo puo essere una sola. Se selezioni piu categorie, la ricerca restituisce articoli la cui categoria predefinita corrisponde ad almeno uno dei valori scelti.",
  },
  {
    key: "categorieWeb",
    label: "Categorie associate",
    includeKey: "categorieWeb_in",
    modeKey: "categorieWeb_in_match",
    icon: Globe2,
    help: "ALMENO UNA restituisce articoli che hanno una qualsiasi categoria selezionata. TUTTE restituisce articoli che hanno tutte le categorie selezionate.",
  },
  {
    key: "categorieWebNot",
    label: "Categorie NON associate",
    includeKey: "categorieWeb_not_in",
    modeKey: "categorieWeb_not_in_match",
    icon: Globe2,
    help: "TUTTE ASSENTI restituisce articoli che non hanno nessuna categoria selezionata. NE MANCA ALMENO UNA restituisce articoli che non hanno almeno una delle categorie selezionate.",
  },
  ],
  BOT: [
    {
      key: "categoriaBotteroPredefinita",
      label: "Categoria predefinita",
      includeKey: "categoriaBotteroPredefinita_in",
      icon: Globe2,
      help: "La categoria predefinita dell'articolo puo essere una sola. Se selezioni piu categorie, la ricerca restituisce articoli la cui categoria predefinita Bottero corrisponde ad almeno uno dei valori scelti.",
    },
    {
      key: "categorieWebBottero",
      label: "Categorie associate",
      includeKey: "categorieWebBottero_in",
      modeKey: "categorieWebBottero_in_match",
      icon: Globe2,
      help: "ALMENO UNA restituisce articoli che hanno una qualsiasi categoria Bottero selezionata. TUTTE restituisce articoli che hanno tutte le categorie selezionate.",
    },
    {
      key: "categorieWebBotteroNot",
      label: "Categorie NON associate",
      includeKey: "categorieWebBottero_not_in",
      modeKey: "categorieWebBottero_not_in_match",
      icon: Globe2,
      help: "TUTTE ASSENTI restituisce articoli che non hanno nessuna categoria Bottero selezionata. NE MANCA ALMENO UNA restituisce articoli che non hanno almeno una delle categorie selezionate.",
    },
  ],
};

const CATEGORY_MAPPING_LOOKUP_FIELD_CONFIGS = [
  ["reparto", "modaRepartoEQ"],
  ["categoria", "modaCategoriaEQ"],
  ["tipo", "modaTipoEQ"],
  ["sottotipo", "modaSottotipoEQ"],
  ["persona", "modaPersonaEQ"],
];

const CATEGORY_MAPPING_MONGO_FIELD_CONFIGS = [
  {
    key: "stagioneConsigliata",
    label: "Stagione consigliata",
    section: "generici",
    field: "stagioneConsigliata",
  },
  {
    key: "utilizzo",
    label: "Utilizzo (generico)",
    section: "generici",
    field: "utilizzo",
  },
  {
    key: "calzatureUtilizzo",
    label: "Utilizzo (calzature)",
    section: "calzature",
    field: "utilizzo",
  },
  {
    key: "sciUtilizzo",
    label: "Utilizzo (sci)",
    section: "sci",
    field: "utilizzo",
  },
  {
    key: "skiBootsUtilizzo",
    label: "Utilizzo (scarponi sci)",
    section: "skiBoots",
    field: "utilizzo",
  },
  {
    key: "bastoniSport",
    label: "Sport bastoni",
    section: "bastoni",
    field: "sport",
  },
  {
    key: "bastoniUtilizzo",
    label: "Specialita sci bastoni",
    section: "bastoni",
    field: "utilizzo",
  },
  {
    key: "bikeUtilizzo",
    label: "Utilizzo (bike)",
    section: "bike",
    field: "utilizzo",
  },
  {
    key: "calzatureAspetto",
    label: "Aspetto calzature",
    section: "calzature",
    field: "aspetto",
  },
  {
    key: "piscinaMareTipo",
    label: "Accessorio mare",
    section: "piscinaMare",
    field: "tipo",
  },
  {
    key: "trekkingCampingAccessori",
    label: "Accessorio camping",
    section: "trekkingCamping",
    field: "accessori",
  },
  {
    key: "arrampicataTipoAttrezzatura",
    label: "Attrezzatura arrampicata",
    section: "arrampicata",
    field: "tipoAttrezzatura",
  },
  {
    key: "golfTipoAccessorioGolf",
    label: "Accessorio golf",
    section: "golf",
    field: "tipoAccessorioGolf",
  },
];

const buildCategoryMappingMongoConfig = (datiUlterioriStandard = {}) =>
  CATEGORY_MAPPING_MONGO_FIELD_CONFIGS.map((field) => ({
    key: field.key,
    label: field.label,
    type: "select",
    options: buildCategoryMappingMongoOptions(
      datiUlterioriStandard?.[field.section]?.[field.field],
    ),
  }));

const buildCategoryMappingMongoOptions = (entry) => {
  const items = Array.isArray(entry?.dati) ? entry.dati : [];
  return items
    .filter((item) => item && item.idPS)
    .map((item) => ({
      value: String(item.idPS),
      label: item.desc ?? String(item.idPS),
    }));
};

const normalizeCategoryMappingOutputs = (source) => ({
  VIG: Array.isArray(source?.VIG) ? source.VIG.map(String) : [],
  BOT: Array.isArray(source?.BOT) ? source.BOT.map(String) : [],
});

const normalizeCategoryMappingDefaultOutputs = (source, outputsSource) => {
  const outputs = normalizeCategoryMappingOutputs(outputsSource);
  const normalizeDefault = (site) => {
    const value = source?.[site];
    const normalized =
      value === undefined || value === null || value === "" ? "" : String(value);
    if (normalized && outputs[site].includes(normalized)) return normalized;
    return outputs[site][0] || "";
  };
  return { VIG: normalizeDefault("VIG"), BOT: normalizeDefault("BOT") };
};

const siteCategoryLabel = (category) => {
  if (!category) return "";
  return (
    String(category.external_id ?? category.externalCategoryId ?? "") +
    " - " +
    (category.path || category.label || "")
  );
};

const siteCategoryValue = (category) =>
  String(category?.external_id ?? category?.externalCategoryId ?? "");

const buildSelectableSiteCategoryTree = (categories = []) => {
  const nodesById = new Map();
  const parentById = new Map();
  (Array.isArray(categories) ? categories : []).forEach((category) => {
    const value = siteCategoryValue(category);
    if (!value || Number(category?.active) === 0) return;
    nodesById.set(value, {
      value,
      label: value + " - " + (category?.label || category?.path || value),
      children: [],
    });
    const parentValue = category?.parent_external_id;
    parentById.set(
      value,
      parentValue === undefined || parentValue === null
        ? ""
        : String(parentValue),
    );
  });

  const roots = [];
  nodesById.forEach((node, value) => {
    const parent = nodesById.get(parentById.get(value));
    if (parent && parent !== node) parent.children.push(node);
    else roots.push(node);
  });
  const sortNodes = (nodes) => {
    nodes.sort((a, b) => a.label.localeCompare(b.label, "it"));
    nodes.forEach((node) => sortNodes(node.children));
    return nodes;
  };
  return sortNodes(roots);
};

const optionValue = (option) => {
  const value = option?.code ?? option?.idPS ?? option?.id ?? option?.value;
  return value === undefined || value === null ? "" : String(value);
};

const optionLabel = (option) => {
  const value = optionValue(option);
  return String(option?.description ?? option?.label ?? option?.desc ?? value);
};

const registerLabelMapValue = (map, value, label) => {
  if (value === undefined || value === null || value === "") {
    return;
  }
  const stringValue = String(value).trim();
  if (!stringValue) {
    return;
  }
  const stringLabel = String(label ?? stringValue).trim();
  [stringValue, stringValue.toUpperCase(), stringValue.toLowerCase()].forEach(
    (key) => {
      if (key && !map.has(key)) {
        map.set(key, stringLabel);
      }
    },
  );
  const numericValue = Number(stringValue);
  if (Number.isFinite(numericValue)) {
    const normalizedNumeric = String(numericValue);
    if (!map.has(normalizedNumeric)) {
      map.set(normalizedNumeric, stringLabel);
    }
  }
};

const buildOptionLabelMap = (options = []) => {
  const map = new Map();
  (Array.isArray(options) ? options : []).forEach((option) => {
    const label = optionLabel(option);
    registerLabelMapValue(map, optionValue(option), label);
    registerLabelMapValue(map, option?.code, label);
    registerLabelMapValue(map, option?.idPS, label);
    registerLabelMapValue(map, option?.id, label);
    registerLabelMapValue(map, option?.value, label);
  });
  return map;
};

const collectTreeCategoryLabels = (nodes = [], map = new Map()) => {
  (Array.isArray(nodes) ? nodes : []).forEach((node) => {
    const value = node?.value ?? node?.id ?? node?.idPS;
    if (value !== undefined && value !== null) {
      registerLabelMapValue(map, value, node?.label ?? node?.name ?? value);
    }
    if (Array.isArray(node?.children)) {
      collectTreeCategoryLabels(node.children, map);
    }
  });
  return map;
};

const resolveLabelMapValue = (labelMap, value) => {
  if (!labelMap) {
    return null;
  }
  const stringValue = String(value).trim();
  const candidates = [
    String(value),
    stringValue,
    stringValue.toUpperCase(),
    stringValue.toLowerCase(),
  ];
  const numericValue = Number(stringValue);
  if (Number.isFinite(numericValue)) {
    candidates.push(String(numericValue));
  }
  for (const candidate of candidates) {
    if (labelMap.has(candidate)) {
      return labelMap.get(candidate);
    }
  }
  return null;
};

const describeValues = (values, labelMap) =>
  (Array.isArray(values) ? values : [values])
    .filter((value) => value !== "" && value !== null && value !== undefined)
    .map((value) => resolveLabelMapValue(labelMap, value) ?? String(value))
    .join(", ");

const groupResolvedCategoryMappings = (mappings = []) => {
  const groups = new Map();
  (Array.isArray(mappings) ? mappings : []).forEach((mapping, index) => {
    const ruleKey = mapping.ruleId ?? `row-${index}`;
    const key = String(ruleKey);
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        ruleId: mapping.ruleId,
        ruleKey: mapping.ruleKey,
        ruleDescription: mapping.ruleDescription,
        priority: mapping.priority,
        createdBy: mapping.createdBy,
        updatedBy: mapping.updatedBy,
        categories: [],
      });
    }
    const categoryId = mapping.categoryId;
    if (categoryId === undefined || categoryId === null || categoryId === "") {
      return;
    }
    const group = groups.get(key);
    const categoryIdString = String(categoryId);
    if (
      !group.categories.some(
        (category) => category.categoryId === categoryIdString,
      )
    ) {
      group.categories.push({
        categoryId: categoryIdString,
        categoryLabel: mapping.categoryLabel,
        categoryPath: mapping.categoryPath,
        isDefaultCandidate: Boolean(mapping.isDefaultCandidate),
      });
    }
  });
  return Array.from(groups.values());
};

const getDefaultCategoryFromMappingGroup = (group) => {
  const categories = Array.isArray(group?.categories) ? group.categories : [];
  const defaultCategory = categories.find(
    (category) => category.isDefaultCandidate,
  );
  return (defaultCategory || categories[0])?.categoryId || "";
};

const normalizeFilterValuesForCompare = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) => String(item ?? "").trim())
      .filter(Boolean)
      .sort();
  }
  const normalized = String(value ?? "").trim();
  return normalized ? [normalized] : [];
};

const hasModaLookupFilterOverrides = (currentFilters, baselineFilters) =>
  CATEGORY_MAPPING_LOOKUP_FIELD_CONFIGS.some(([fieldKey]) =>
    ["eq", "in", "not_in"].some((suffix) => {
      const key = `${fieldKey}_${suffix}`;
      const current = normalizeFilterValuesForCompare(currentFilters?.[key]);
      const baseline = normalizeFilterValuesForCompare(baselineFilters?.[key]);
      return (
        current.length !== baseline.length ||
        current.some((value, index) => value !== baseline[index])
      );
    }),
  );

const cloneFilters = (source) => {
  const base = buildDefaultFilters();
  Object.entries(source ?? {}).forEach(([key, value]) => {
    if (key === "codicePS") {
      base.idPs = value;
      return;
    }
    if (key === "mongoFilters" && value && typeof value === "object") {
      const cloned = {};
      Object.entries(value).forEach(([mongoKey, mongoValue]) => {
        cloned[mongoKey] = Array.isArray(mongoValue)
          ? [...mongoValue]
          : mongoValue;
      });
      base.mongoFilters = cloned;
      return;
    }
    base[key] = Array.isArray(value) ? [...value] : value;
  });
  return base;
};

const normalizeCategoryMappingProductFilters = (source) => {
  const normalized = cloneFilters(source);
  CATEGORY_MAPPING_LOOKUP_FIELD_CONFIGS.forEach(([fieldKey]) => {
    const eqKey = fieldKey + "_eq";
    const inKey = fieldKey + "_in";
    const notInKey = fieldKey + "_not_in";
    const inValues = Array.isArray(normalized[inKey]) ? normalized[inKey] : [];
    normalized[eqKey] = normalized[eqKey] || inValues[0] || "";
    normalized[inKey] = [];
    normalized[notInKey] = [];
  });
  const mongoFilters = { ...(normalized.mongoFilters || {}) };
  CATEGORY_MAPPING_MONGO_FIELD_CONFIGS.forEach((field) => {
    const eqKey = field.key + "_eq";
    const inKey = field.key + "_in";
    const notInKey = field.key + "_not_in";
    const inValues = Array.isArray(mongoFilters[inKey]) ? mongoFilters[inKey] : [];
    mongoFilters[eqKey] = mongoFilters[eqKey] || inValues[0] || "";
    delete mongoFilters[inKey];
    delete mongoFilters[notInKey];
  });
  normalized.mongoFilters = mongoFilters;
  return normalized;
};

const cleanEntries = (source) =>
  Object.entries(source).reduce((acc, [key, value]) => {
    if (Array.isArray(value)) {
      const cleaned = value.filter(
        (item) => item !== "" && item !== null && item !== undefined,
      );
      if (cleaned.length) {
        acc[key] = cleaned;
      }
      return acc;
    }
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (trimmed) {
        acc[key] = trimmed;
      }
      return acc;
    }
    if (value && typeof value === "object") {
      const nested = cleanEntries(value);
      if (Object.keys(nested).length) {
        acc[key] = nested;
      }
      return acc;
    }
    if (typeof value === "boolean") {
      if (value) {
        acc[key] = value;
      }
      return acc;
    }
    if (value !== undefined && value !== null && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});

const normalizeConditionValue = (value) => String(value ?? "").trim().toUpperCase();

const conditionSignature = (condition) => {
  const source = condition?.source || "";
  const path = source === "moda"
    ? condition?.field || condition?.path || ""
    : condition?.path || condition?.field || "";
  const operator = condition?.operator === "eq" ? "in" : condition?.operator || "eq";
  const rawValues = operator === "in" || operator === "not_in"
    ? Array.isArray(condition?.values)
      ? condition.values
      : [condition?.value]
    : [condition?.value];
  const values = rawValues
    .map(normalizeConditionValue)
    .filter(Boolean)
    .sort()
    .join(",");
  return `${source}:${path}:${operator}:${values}`;
};

const conditionsSignature = (conditions) =>
  (Array.isArray(conditions) ? conditions : [])
    .map(conditionSignature)
    .sort()
    .join("||");

const buildCategoryMappingConditionsFromFilters = (filters) => {
  const conditions = [];
  CATEGORY_MAPPING_LOOKUP_FIELD_CONFIGS.forEach(([field]) => {
    const eqValue = filters?.[`${field}_eq`];
    const inValues = Array.isArray(filters?.[`${field}_in`]) ? filters[`${field}_in`] : [];
    const notInValues = Array.isArray(filters?.[`${field}_not_in`]) ? filters[`${field}_not_in`] : [];
    if (normalizeConditionValue(eqValue)) {
      conditions.push({ source: "moda", field, operator: "eq", value: eqValue });
    } else if (notInValues.filter(normalizeConditionValue).length) {
      conditions.push({ source: "moda", field, operator: "not_in", values: notInValues });
    } else if (inValues.filter(normalizeConditionValue).length) {
      conditions.push({ source: "moda", field, operator: "in", values: inValues });
    }
  });
  CATEGORY_MAPPING_MONGO_FIELD_CONFIGS.forEach((field) => {
    const inValues = Array.isArray(filters?.mongoFilters?.[`${field.key}_in`])
      ? filters.mongoFilters[`${field.key}_in`]
      : [];
    const notInValues = Array.isArray(filters?.mongoFilters?.[`${field.key}_not_in`])
      ? filters.mongoFilters[`${field.key}_not_in`]
      : [];
    const path = `datiUlteriori.${field.section}.${field.field}.valueId`;
    if (notInValues.filter(normalizeConditionValue).length) {
      conditions.push({ source: "mongo", path, operator: "not_in", values: notInValues });
    } else if (inValues.filter(normalizeConditionValue).length) {
      conditions.push({ source: "mongo", path, operator: "in", values: inValues });
    }
  });
  return conditions;
};

const findExactResolvedMapping = (result, filters, ignoredRuleId = null) => {
  const expectedSignature = conditionsSignature(
    buildCategoryMappingConditionsFromFilters(filters),
  );
  if (!expectedSignature) return null;
  const normalizedIgnoredRuleId =
    ignoredRuleId === null || ignoredRuleId === undefined
      ? null
      : String(ignoredRuleId);
  const rules = new Map();
  Object.values(result ?? {}).forEach((siteResult) => {
    (siteResult?.appliedRules || []).forEach((rule) => {
      if (
        rule?.ruleId &&
        String(rule.ruleId) !== normalizedIgnoredRuleId &&
        !rules.has(rule.ruleId)
      ) {
        rules.set(rule.ruleId, rule);
      }
    });
  });
  return Array.from(rules.values()).find(
    (rule) => conditionsSignature(rule.conditions) === expectedSignature,
  ) || null;
};

function ModaArticoliAdvancedFiltersModal({
  open,
  onClose,
  onApply,
  initialFilters = {},
  lookupOptions = {},
  stagioneOptions = [],
  datiUlterioriStandard = {},
  temaColori = "rootTema",
  categoryMappingMode = false,
  categoryMappingInputLocked = false,
  editingCategoryMappingRuleId = null,
  categoryMappingTitle = "Mappatura categorie da filtri MODA",
  initialCategoryMappingName = "",
  initialCategoryMappingPanel = null,
  siteCategories = DEFAULT_SITE_CATEGORIES,
  initialCategoryMappingOutputs = DEFAULT_CATEGORY_MAPPING_OUTPUTS,
  initialCategoryMappingDefaultOutputs = DEFAULT_CATEGORY_MAPPING_OUTPUTS,
  baselineFilters = initialFilters,
  onResolveExistingMappings,
  onApplyExistingMapping,
  onDeleteCategoryMapping,
  onFiltersChange,
  embedded = false,
  categoryMappingProductMode = false,
  categoryMappingRequirements = [],
  initialCategoryMappingTab,
  persistFiltersOnChange = true,
  canReadCosti = false,
}) {
  const { tuttiIcampiRicerca } = useLogisticaConfiguration();
  const categoryMappingLookupKeys = useMemo(() => new Set(
  CATEGORY_MAPPING_LOOKUP_FIELD_CONFIGS.filter(
    ([, configKey]) =>
      tuttiIcampiRicerca?.[configKey]?.web_cat_mapping === true,
  ).map(([fieldKey]) => fieldKey),
), [tuttiIcampiRicerca]);


  const visible = embedded || open;
  const initialMappingPanel = categoryMappingProductMode
    ? "filters"
    : initialCategoryMappingPanel || "existing";
  const [localFilters, setLocalFilters] = useState(() =>
    categoryMappingProductMode
      ? normalizeCategoryMappingProductFilters(initialFilters)
      : cloneFilters(initialFilters),
  );
  const [filtersDirty, setFiltersDirty] = useState(false);
  const wasOpenRef = useRef(false);
  const [activeTab, setActiveTab] = useState(
    categoryMappingMode ? initialCategoryMappingTab || "moda" : "base",
  );
  const [activeValueKey, setActiveValueKey] = useState(
    categoryMappingMode ? "reparto" : "brand",
  );
  const [activeMappingSite, setActiveMappingSite] = useState("VIG");
  const [categoryMappingPanel, setCategoryMappingPanel] = useState(initialMappingPanel);
  const [categoryMappingName, setCategoryMappingName] = useState(
    initialCategoryMappingName || "",
  );
  const [categorySearch, setCategorySearch] = useState("");
  const [categoryTreeExpandedBySite, setCategoryTreeExpandedBySite] = useState(
    {},
  );
  const [valuePickerModes, setValuePickerModes] = useState({});
  const [categoryMappingOutputs, setCategoryMappingOutputs] = useState(() =>
    normalizeCategoryMappingOutputs(initialCategoryMappingOutputs),
  );
  const [categoryMappingDefaultOutputs, setCategoryMappingDefaultOutputs] =
    useState(() =>
      normalizeCategoryMappingDefaultOutputs(
        initialCategoryMappingDefaultOutputs,
        initialCategoryMappingOutputs,
      ),
    );
  const [existingMappingsLoading, setExistingMappingsLoading] = useState(false);
  const [existingMappingsError, setExistingMappingsError] = useState("");
  const [existingMappingsResult, setExistingMappingsResult] = useState(null);
  const [existingMappingsReloadKey, setExistingMappingsReloadKey] = useState(0);

  useEffect(() => {
    if (visible && !wasOpenRef.current) {
      setLocalFilters(
        categoryMappingProductMode
          ? normalizeCategoryMappingProductFilters(initialFilters)
          : cloneFilters(initialFilters),
      );
      setFiltersDirty(false);
      setActiveTab(categoryMappingMode ? initialCategoryMappingTab || "moda" : "base");
      setActiveValueKey(categoryMappingMode ? "reparto" : "brand");
      setActiveMappingSite("VIG");
      setCategoryMappingPanel(categoryMappingMode ? initialMappingPanel : "filters");
      setCategoryMappingName(initialCategoryMappingName || "");
      setCategorySearch("");
      setCategoryTreeExpandedBySite({});
      setValuePickerModes({});
      setExistingMappingsError("");
      setExistingMappingsResult(null);
      setExistingMappingsReloadKey((prev) => prev + 1);
      setCategoryMappingOutputs(
        normalizeCategoryMappingOutputs(initialCategoryMappingOutputs),
      );
      setCategoryMappingDefaultOutputs(
        normalizeCategoryMappingDefaultOutputs(
          initialCategoryMappingDefaultOutputs,
          initialCategoryMappingOutputs,
        ),
      );
    }
    wasOpenRef.current = visible;
  }, [
    visible,
    initialFilters,
    categoryMappingMode,
    categoryMappingProductMode,
    initialCategoryMappingOutputs,
    initialCategoryMappingDefaultOutputs,
    initialCategoryMappingName,
    initialCategoryMappingPanel,
    initialCategoryMappingTab,
    initialMappingPanel,
  ]);

  useEffect(() => {
    if (!visible || !categoryMappingProductMode || filtersDirty) return;
    setLocalFilters(normalizeCategoryMappingProductFilters(initialFilters));
  }, [categoryMappingProductMode, filtersDirty, initialFilters, visible]);

  const resolveExistingMappingsForFilters = useCallback(
    async (filters, options = {}) => {
      if (typeof onResolveExistingMappings !== "function") {
        setExistingMappingsResult(null);
        return null;
      }
      const updateState = options.updateState !== false;
      if (updateState) {
        setExistingMappingsLoading(true);
        setExistingMappingsError("");
      }
      try {
        const result = await Promise.resolve(
          onResolveExistingMappings(cleanEntries(filters)),
        );
        if (updateState) {
          setExistingMappingsResult(result ?? null);
        }
        return result ?? null;
      } catch (error) {
        if (updateState) {
          setExistingMappingsResult(null);
          setExistingMappingsError(
            error?.message || "Errore caricamento map esistenti.",
          );
        }
        throw error;
      } finally {
        if (updateState) {
          setExistingMappingsLoading(false);
        }
      }
    },
    [onResolveExistingMappings],
  );

  useEffect(() => {
    if (
      !visible ||
      !categoryMappingMode ||
      (!categoryMappingProductMode && categoryMappingPanel !== "existing")
    ) {
      return;
    }
    let cancelled = false;
    resolveExistingMappingsForFilters(localFilters)
      .then((result) => {
        if (cancelled) return;
        setExistingMappingsResult(result ?? null);
      })
      .catch(() => {
        // Error state is already handled by resolveExistingMappingsForFilters.
      });
    return () => {
      cancelled = true;
    };
  }, [
    categoryMappingMode,
    categoryMappingPanel,
    categoryMappingProductMode,
    existingMappingsReloadKey,
    localFilters,
    visible,
    resolveExistingMappingsForFilters,
  ]);

  useEffect(() => {
    if (
      !visible ||
      !categoryMappingMode ||
      !filtersDirty ||
      !persistFiltersOnChange ||
      typeof onFiltersChange !== "function"
    ) {
      return;
    }
    onFiltersChange(cleanEntries(localFilters));
  }, [categoryMappingMode, filtersDirty, localFilters, onFiltersChange, persistFiltersOnChange, visible]);

  const multiSelectOptions = useMemo(
    () => ({
      brand: lookupOptions?.brand ?? [],
      tagModa: lookupOptions?.tagModa ?? [],
      persona: lookupOptions?.persona ?? [],
      reparto: lookupOptions?.reparto ?? [],
      categoria: lookupOptions?.categoria ?? [],
      tipo: lookupOptions?.tipo ?? [],
      sottotipo: lookupOptions?.sottotipo ?? [],
      stagione: stagioneOptions ?? [],
    }),
    [lookupOptions, stagioneOptions],
  );

  const lookupFields = useMemo(
    () =>
      categoryMappingMode
        ? LOOKUP_FILTERS.filter((field) =>
            categoryMappingLookupKeys.has(field.key),
          )
        : LOOKUP_FILTERS,
    [categoryMappingMode, categoryMappingLookupKeys],
  );

  const userOptions = useMemo(
    () => lookupOptions?.utenti ?? [],
    [lookupOptions],
  );
  const mongoConfig = useMemo(
    () => buildMongoArticoliFiltersConfig(datiUlterioriStandard),
    [datiUlterioriStandard],
  );
  const mongoSelectConfig = useMemo(
    () => mongoConfig.filter((item) => item.type !== "tree"),
    [mongoConfig],
  );
  const categoryMappingMongoSelectConfig = useMemo(
    () => buildCategoryMappingMongoConfig(datiUlterioriStandard),
    [datiUlterioriStandard],
  );
  const activeMongoSelectConfig = categoryMappingMode
    ? categoryMappingMongoSelectConfig
    : mongoSelectConfig;
  const categorieWebTree = useMemo(
    () =>
      Array.isArray(datiUlterioriStandard?.categorieWeb)
        ? datiUlterioriStandard.categorieWeb
        : [],
    [datiUlterioriStandard],
  );
  const categoryTreesBySite = useMemo(() => {
    const vigTree = buildSelectableSiteCategoryTree(siteCategories?.VIG);
    return {
      VIG: vigTree.length ? vigTree : categorieWebTree,
      BOT: buildSelectableSiteCategoryTree(siteCategories?.BOT),
    };
  }, [categorieWebTree, siteCategories]);

  const updateLocalFilters = (updater) => {
    if (categoryMappingMode && categoryMappingInputLocked) return;
    setFiltersDirty(true);
    setLocalFilters(updater);
  };

  const setField = (name, value) => {
    updateLocalFilters((prev) => ({ ...prev, [name]: value }));
  };

  const setMongoFilters = (updater) => {
    updateLocalFilters((prev) => ({
      ...prev,
      mongoFilters:
        typeof updater === "function"
          ? updater(prev.mongoFilters ?? {})
          : (updater ?? {}),
    }));
  };

  const getLookupState = (field) => {
    const includeName = `${field.key}_in`;
    const excludeName = `${field.key}_not_in`;
    if (categoryMappingProductMode) {
      const eqValue = localFilters[field.key + "_eq"];
      const includeValues = Array.isArray(localFilters[includeName])
        ? localFilters[includeName]
        : [];
      return {
        mode: "eq",
        values: eqValue ? [eqValue] : includeValues.slice(0, 1),
      };
    }
    const explicitMode = valuePickerModes[field.key];
    if (explicitMode === "eq") {
      return {
        mode: "eq",
        values: localFilters[`${field.key}_eq`]
          ? [localFilters[`${field.key}_eq`]]
          : [],
      };
    }
    if (explicitMode === "not_in") {
      return { mode: "not_in", values: localFilters[excludeName] ?? [] };
    }
    if (explicitMode === "in") {
      return { mode: "in", values: localFilters[includeName] ?? [] };
    }
    if (isAdvancedSearchValueActive(localFilters[`${field.key}_eq`])) {
      return { mode: "eq", values: [localFilters[`${field.key}_eq`]] };
    }
    if (isAdvancedSearchValueActive(localFilters[excludeName])) {
      return { mode: "not_in", values: localFilters[excludeName] ?? [] };
    }
    return { mode: "in", values: localFilters[includeName] ?? [] };
  };

  const updateLookupValues = (field, mode, values) => {
    setValuePickerModes((prev) => ({ ...prev, [field.key]: mode }));
    const includeName = `${field.key}_in`;
    const excludeName = `${field.key}_not_in`;
    updateLocalFilters((prev) => ({
      ...prev,
      [`${field.key}_eq`]: mode === "eq" ? (values[0] ?? "") : "",
      [includeName]: mode === "in" ? values : [],
      [excludeName]: mode === "not_in" ? values : [],
    }));
  };

  const getBotSnapshotCategoryState = () => {
    const explicitMode = valuePickerModes.botSnapshotCategory;
    if (explicitMode === "not_in") {
      return {
        mode: "not_in",
        values: localFilters.botSnapshotCategory_not_in ?? [],
      };
    }
    if (explicitMode === "in") {
      return {
        mode: "in",
        values: localFilters.botSnapshotCategory_in ?? [],
      };
    }
    if (
      isAdvancedSearchValueActive(localFilters.botSnapshotCategory_not_in)
    ) {
      return {
        mode: "not_in",
        values: localFilters.botSnapshotCategory_not_in ?? [],
      };
    }
    return {
      mode: "in",
      values: localFilters.botSnapshotCategory_in ?? [],
    };
  };

  const updateBotSnapshotCategoryValues = (mode, values) => {
    setValuePickerModes((prev) => ({
      ...prev,
      botSnapshotCategory: mode,
    }));
    updateLocalFilters((prev) => ({
      ...prev,
      botSnapshotCategory_in: mode === "in" ? values : [],
      botSnapshotCategory_not_in: mode === "not_in" ? values : [],
    }));
  };

  const getPublicationDestinationState = () => {
    const explicitMode = valuePickerModes.publicationDestinations;
    if (explicitMode === "not_in") {
      return {
        mode: "not_in",
        values: localFilters.destinazioni_not_in ?? [],
      };
    }
    if (explicitMode === "in") {
      return { mode: "in", values: localFilters.destinazioni_in ?? [] };
    }
    if (isAdvancedSearchValueActive(localFilters.destinazioni_not_in)) {
      return {
        mode: "not_in",
        values: localFilters.destinazioni_not_in ?? [],
      };
    }
    return { mode: "in", values: localFilters.destinazioni_in ?? [] };
  };

  const updatePublicationDestinationValues = (mode, values) => {
    setValuePickerModes((prev) => ({
      ...prev,
      publicationDestinations: mode,
    }));
    updateLocalFilters((prev) => ({
      ...prev,
      destinazioni_in: mode === "in" ? values : [],
      destinazioni_not_in: mode === "not_in" ? values : [],
    }));
  };

  const getMongoSelectState = (field) => {
    const includeKey = `${field.key}_in`;
    const excludeKey = `${field.key}_not_in`;
    if (categoryMappingProductMode) {
      const eqValue = localFilters.mongoFilters?.[field.key + "_eq"];
      const includeValues = Array.isArray(localFilters.mongoFilters?.[includeKey])
        ? localFilters.mongoFilters[includeKey]
        : [];
      return {
        mode: "eq",
        values: eqValue ? [eqValue] : includeValues.slice(0, 1),
      };
    }
    const explicitMode = valuePickerModes[`mongo:${field.key}`];
    if (explicitMode === "not_in") {
      return {
        mode: "not_in",
        values: localFilters.mongoFilters?.[excludeKey] ?? [],
      };
    }
    if (explicitMode === "in") {
      return {
        mode: "in",
        values: localFilters.mongoFilters?.[includeKey] ?? [],
      };
    }
    if (isAdvancedSearchValueActive(localFilters.mongoFilters?.[excludeKey])) {
      return {
        mode: "not_in",
        values: localFilters.mongoFilters?.[excludeKey] ?? [],
      };
    }
    return {
      mode: "in",
      values: localFilters.mongoFilters?.[includeKey] ?? [],
    };
  };

  const updateMongoSelectValues = (field, mode, values) => {
    setValuePickerModes((prev) => ({ ...prev, [`mongo:${field.key}`]: mode }));
    const includeKey = `${field.key}_in`;
    const excludeKey = `${field.key}_not_in`;
    const eqKey = field.key + "_eq";
    setMongoFilters((prev) => {
      const next = { ...prev };
      delete next[includeKey];
      delete next[excludeKey];
      delete next[eqKey];
      if (values.length) {
        if (categoryMappingProductMode || mode === "eq") {
          next[eqKey] = values[0];
        } else {
          next[mode === "not_in" ? excludeKey : includeKey] = values;
        }
      }
      return next;
    });
  };

  const updateCategoryValues = (field, values) => {
    setMongoFilters((prev) => {
      const next = { ...prev };
      if (values.length) {
        next[field.includeKey] = values;
      } else {
        delete next[field.includeKey];
      }
      return next;
    });
  };

  const updateCategoryMode = (field, mode) => {
    if (!field.modeKey) {
      return;
    }
    setMongoFilters((prev) => ({
      ...prev,
      [field.modeKey]: mode,
    }));
  };

  const hasModaOverrides = useMemo(
    () =>
      categoryMappingMode &&
      hasModaLookupFilterOverrides(
        localFilters,
        categoryMappingProductMode
          ? normalizeCategoryMappingProductFilters(baselineFilters)
          : baselineFilters,
      ),
    [baselineFilters, categoryMappingMode, categoryMappingProductMode, localFilters],
  );

  const categoryMappingModaWarning =
    hasModaOverrides && categoryMappingMode && categoryMappingProductMode ? (
      <div className="pa2 mb3 br2 ba b--red dark-red lh-copy f7">
        queste modifiche non aggiornano subito Moda. al salvataggio
        dell'articolo verranno registrate per il successivo allineamento del
        gestionale
      </div>
    ) : null;

  const summaryEntries = useMemo(() => {
    const labelMap = {
      idPs: "Codice PS",
      codiceVS: "Codice VS",
      codiceProduttore: "Codice produttore",
      brand: "Brand (=)",
      brand_in: "Brand (IN)",
      brand_not_in: "Brand (NOT IN)",
      persona: "Persona (=)",
      persona_in: "Persona (IN)",
      persona_not_in: "Persona (NOT IN)",
      reparto: "Reparto (=)",
      reparto_in: "Reparto (IN)",
      reparto_not_in: "Reparto (NOT IN)",
      categoria: "Categoria (=)",
      categoria_in: "Categoria (IN)",
      categoria_not_in: "Categoria (NOT IN)",
      tipo: "Tipo (=)",
      tipo_in: "Tipo (IN)",
      tipo_not_in: "Tipo (NOT IN)",
      sottotipo: "Sottotipo (=)",
      sottotipo_in: "Sottotipo (IN)",
      sottotipo_not_in: "Sottotipo (NOT IN)",
      stagione: "Stagione (=)",
      stagione_in: "Stagione (IN)",
      stagione_not_in: "Stagione (NOT IN)",
      pubblicatoDa: "Data pubblicazione da",
      pubblicatoA: "Data pubblicazione a",
      immaginiCreateDa: "Data creazione immagini da",
      immaginiCreateA: "Data creazione immagini a",
      ut_import_done: "Ultimo import da",
      importatoDa: "Data import da",
      importatoA: "Data import a",
      importRegistrato: "Import registrato",
      ut_pubbl_done: "Testi fatti da",
      ut_pubbl_pren: "Testi assegnati a",
      ut_imm_done: "Immagini fatte da",
      ut_imm_pren: "Immagini assegnate a",
      ut_richiede: "Richiesta pubbl. da",
      assignedTo: "Assegnato a",
      pubblicato: "Pubblicato",
      visibility: "Visibilita",
      f_467_attivo_ecom: "Attivo su e-com (feature)",
      attivo: "Effettivamente attivo su Prestashop",
      testi_importati: "Testi importati",
      deactivation_reason: "Ragioni invisibile/disattivo",
      annullato: "Annullato su Moda",
      troppeVarianti: "Troppe varianti",
      ha_immagine: "Ha immagine",
      imm_nonsitrova: "Immagine non si trova",
      botTextConsolidationStatus: "Consolidamento dati/testi BOT",
      botImageConsolidationStatus: "Consolidamento immagini BOT",
      botSnapshotCategory_in: "Cat ps BOT al 31/07/2026 (IN)",
      botSnapshotCategory_not_in: "Cat ps BOT al 31/07/2026 (NOT IN)",
      botSnapshotHasImage: "Immagine associata 31/07/2026",
      vsArticoliGruppo: "Gruppo articolo VS",
      mostra_import_bot: "Da importare da BOT",
      mostra_export_vig: "Da esportare a BOT",
      destinazioni_in: "Destinazioni (IN)",
      destinazioni_not_in: "Destinazioni (NOT IN)",
      ...PREZZI_FILTER_LABELS,
      tagModa_in: "Tag Moda (IN)",
      tagModa_not_in: "Tag Moda (NOT IN)",
    };
    const mongoLabelMap = {
      categoriaPredefinita: "Categoria web predefinita VIG",
      categorieWeb: "Categorie web VIG",
      categoriaBotteroPredefinita: "Categoria web predefinita BOT",
      categorieWebBottero: "Categorie web BOT",
      stagioneConsigliata: "Stagione consigliata",
      utilizzo: categoryMappingMode ? "Utilizzo (generico)" : "Utilizzo",
      calzatureUtilizzo: "Utilizzo (calzature)",
      sciUtilizzo: "Utilizzo (sci)",
      skiBootsUtilizzo: "Utilizzo (scarponi sci)",
      bastoniSport: "Sport bastoni",
      bastoniUtilizzo: "Specialita sci bastoni",
      bikeUtilizzo: "Utilizzo (bike)",
      calzatureAspetto: "Aspetto calzature",
      piscinaMareTipo: "Accessorio mare",
      trekkingCampingAccessori: "Accessorio camping",
      arrampicataTipoAttrezzatura: "Attrezzatura arrampicata",
      golfTipoAccessorioGolf: "Accessorio golf",
    };
    const optionMaps = {
      brand: buildOptionLabelMap(multiSelectOptions.brand),
      tagModa: buildOptionLabelMap(multiSelectOptions.tagModa),
      persona: buildOptionLabelMap(multiSelectOptions.persona),
      reparto: buildOptionLabelMap(multiSelectOptions.reparto),
      categoria: buildOptionLabelMap(multiSelectOptions.categoria),
      tipo: buildOptionLabelMap(multiSelectOptions.tipo),
      sottotipo: buildOptionLabelMap(multiSelectOptions.sottotipo),
      stagione: buildOptionLabelMap(multiSelectOptions.stagione),
      stato: buildOptionLabelMap([
        { value: "ACTIVE", label: "Attivo" },
        { value: "INACTIVE", label: "Inattivo" },
        { value: "ARCHIVED", label: "Archiviato" },
      ]),
      pubblicato: buildOptionLabelMap(PUBBLICATO_OPTIONS),
      visibility: buildOptionLabelMap(VISIBILITY_OPTIONS),
      f_467_attivo_ecom: buildOptionLabelMap([
        { value: "SI", label: "SI" },
        { value: "NO", label: "NO" },
      ]),
      attivo: buildOptionLabelMap(BOOLEAN_OPTIONS),
      testi_importati: buildOptionLabelMap(BOOLEAN_OPTIONS),
      annullato: buildOptionLabelMap(BOOLEAN_OPTIONS),
      troppeVarianti: buildOptionLabelMap(BOOLEAN_OPTIONS),
      ha_immagine: buildOptionLabelMap(BOOLEAN_OPTIONS),
      imm_nonsitrova: buildOptionLabelMap(BOOLEAN_OPTIONS),
      botTextConsolidationStatus: buildOptionLabelMap(BOT_CONSOLIDATION_OPTIONS),
      botImageConsolidationStatus: buildOptionLabelMap(BOT_CONSOLIDATION_OPTIONS),
      vsArticoliGruppo: buildOptionLabelMap(VS_ARTICOLI_GRUPPO_OPTIONS),
      mostra_import_bot: buildOptionLabelMap(BOOLEAN_OPTIONS),
      mostra_export_vig: buildOptionLabelMap(BOOLEAN_OPTIONS),
      destinazioni: buildOptionLabelMap(PUBLICATION_DESTINATION_OPTIONS),
      botSnapshotCategory: buildOptionLabelMap(
        lookupOptions?.botSnapshotCategory ?? [],
      ),
      botSnapshotHasImage: buildOptionLabelMap([
        { value: "1", label: "Sì" },
        { value: "0", label: "No" },
      ]),
      ut_import_done: buildOptionLabelMap(userOptions),
      ut_pubbl_done: buildOptionLabelMap(userOptions),
      ut_pubbl_pren: buildOptionLabelMap(userOptions),
      ut_imm_done: buildOptionLabelMap(userOptions),
      ut_imm_pren: buildOptionLabelMap(userOptions),
      ut_richiede: buildOptionLabelMap(userOptions),
      assignedTo: buildOptionLabelMap(userOptions),
    };
    const mongoOptionMaps = activeMongoSelectConfig.reduce((acc, field) => {
      acc[field.key] = buildOptionLabelMap(field.options ?? []);
      return acc;
    }, {});
    const categoryLabelMaps = {
      VIG: collectTreeCategoryLabels(categoryTreesBySite.VIG),
      BOT: collectTreeCategoryLabels(categoryTreesBySite.BOT),
    };
    const entries = [];
    Object.entries(localFilters).forEach(([key, value]) => {
      if (key === "mongoFilters" || key === "codiciIncollatiTipo") {
        return;
      }
      if (key === "codiciIncollati") {
        const { codes } = parseCodiciIncollati(value);
        if (codes.length) {
          entries.push([
            "Codici incollati",
            describeCodiciIncollati(codes, localFilters.codiciIncollatiTipo),
            "input:codiciIncollati",
          ]);
        }
        return;
      }
      const baseKey = key.replace(/_(in|not_in|eq)$/, "");
      const valueLabelMap = optionMaps[baseKey] ?? optionMaps[key];
      if (Array.isArray(value) && value.length) {
        entries.push([
          labelMap[key] ?? key,
          describeValues(value, valueLabelMap),
          "input:" + key,
        ]);
      } else if (typeof value === "string" && value.trim()) {
        entries.push([
          labelMap[key] ?? key,
          describeValues(value.trim(), valueLabelMap),
          "input:" + key,
        ]);
      } else if (typeof value === "boolean" && value) {
        entries.push([labelMap[key] ?? key, "Si", "input:" + key]);
      }
    });
    Object.entries(localFilters.mongoFilters ?? {}).forEach(
      ([mongoKey, mongoValue]) => {
        if (mongoKey.endsWith("_match")) {
          return;
        }
        const isEq = mongoKey.endsWith("_eq");
        if (
          (!isEq && (!Array.isArray(mongoValue) || mongoValue.length === 0)) ||
          (isEq && !normalizeConditionValue(mongoValue))
        ) {
          return;
        }
        const isNotIn = mongoKey.endsWith("_not_in");
        const baseKey = mongoKey.replace(/_(in|not_in|eq)$/, "");
        const labelBase = mongoLabelMap[baseKey] ?? baseKey;
        const categoryLabelMap =
          baseKey === "categoriaBotteroPredefinita" ||
          baseKey === "categorieWebBottero"
            ? categoryLabelMaps.BOT
            : baseKey === "categoriaPredefinita" || baseKey === "categorieWeb"
              ? categoryLabelMaps.VIG
              : undefined;
        const valueLabelMap =
          mongoOptionMaps[baseKey] ?? categoryLabelMap;
        entries.push([
          `${labelBase} (${isEq ? "=" : isNotIn ? "NOT IN" : "IN"})`,
          describeValues(mongoValue, valueLabelMap),
          "mongo:" + mongoKey,
        ]);
      },
    );
    return entries;
  }, [
    activeMongoSelectConfig,
    categoryMappingMode,
    categoryTreesBySite,
    localFilters,
    lookupOptions?.botSnapshotCategory,
    multiSelectOptions,
    userOptions,
  ]);

  const requiredCategoryMappingFields = useMemo(() => {
    const moda = new Set();
    const mongo = new Set();
    if (!categoryMappingProductMode) return { moda, mongo };
    categoryMappingRequirements.forEach((siteRequirement) => {
      (siteRequirement.missingRequirements || []).forEach((requirement) => {
        if (requirement.source === "moda") {
          const fieldKey = String(requirement.field || requirement.path || "")
            .split(".")
            .pop();
          if (CATEGORY_MAPPING_LOOKUP_FIELD_CONFIGS.some(([key]) => key === fieldKey)) {
            moda.add(fieldKey);
          }
          return;
        }
        if (requirement.source === "mongo") {
          const normalizedPath = String(requirement.path || requirement.field || "")
            .replace(/^datiUlteriori\./, "")
            .replace(".valueId", "");
          const field = CATEGORY_MAPPING_MONGO_FIELD_CONFIGS.find(
            (item) => item.section + "." + item.field === normalizedPath,
          );
          if (field) mongo.add(field.key);
        }
      });
    });
    return { moda, mongo };
  }, [categoryMappingProductMode, categoryMappingRequirements]);

  const countTabKeys = (keys) =>
    keys.filter((key) => isAdvancedSearchValueActive(localFilters[key])).length;
  const modaTabCount = lookupFields.reduce((count, field) => {
    const state = getLookupState(field);
    return count + (state.values.length ? 1 : 0);
  }, 0);
  const mongoTabFilters = localFilters.mongoFilters ?? {};
  const categoryTabCount = (site) =>
    categoryMappingMode
      ? 0
      : CATEGORY_VALUE_FILTERS_BY_SITE[site].filter((field) =>
          isAdvancedSearchValueActive(mongoTabFilters[field.includeKey]),
        ).length;
  const webTabCount = activeMongoSelectConfig.filter((field) => {
    const state = getMongoSelectState(field);
    return state.values.length > 0;
  }).length;
  const codiciIncollatiParsed = parseCodiciIncollati(localFilters.codiciIncollati);
  const tabCounts = {
    codici: codiciIncollatiParsed.codes.length ? 1 : 0,
    tagModa: getLookupState(TAG_MODA_FIELD).values.length ? 1 : 0,
    base: countTabKeys([
      "codiceVS",
      "idPs",
      "nome",
      "codiceProduttore",
      "stato",
      "colore",
      "stockMin",
      "stockMax",
      "stockModaMin",
      "stockModaMax",
    ]),
    moda: modaTabCount,
    pubblicazione: countTabKeys([
      "pubblicato",
      "visibility",
      "f_467_attivo_ecom",
      "attivo",
      "testi_importati",
      "deactivation_reason",
    ]),
    bot: countTabKeys([
      "botTextConsolidationStatus",
      "botImageConsolidationStatus",
      "botSnapshotCategory_in",
      "botSnapshotCategory_not_in",
      "botSnapshotHasImage",
      "vsArticoliGruppo",
      "mostra_import_bot",
      "mostra_export_vig",
    ]),
    workflow: countTabKeys([
      "destinazioni_in",
      "destinazioni_not_in",
      "annullato",
      "troppeVarianti",
      "ha_immagine",
      "imm_nonsitrova",
      "priorityMin",
      "priorityMax",
      "aggiornatoDa",
      "aggiornatoA",
      "importatoDa",
      "importatoA",
      "importRegistrato",
      "ut_import_done",
      "pubblicatoDa",
      "pubblicatoA",
      "immaginiCreateDa",
      "immaginiCreateA",
      "ut_pubbl_done",
      "ut_pubbl_pren",
      "ut_imm_done",
      "ut_imm_pren",
      "ut_richiede",
      "assignedTo",
    ]),
    prezzi: countTabKeys(
      PREZZI_FILTER_FIELDS.filter((field) => canReadCosti || !field.riservato)
        .flatMap((field) => [field.min, field.max]),
    ),
    web: webTabCount,
    webVig: categoryTabCount("VIG"),
    webBot: categoryTabCount("BOT"),
  };

  const tabs = categoryMappingMode
    ? categoryMappingPanel === "mapping"
      ? CATEGORY_MAPPING_SITES.map((site) => ({
          key: site.key,
          label: site.label,
          icon: Globe2,
          activeCount: (categoryMappingOutputs[site.key] || []).length,
        }))
      : categoryMappingPanel === "existing"
        ? [
            {
              key: "existing",
              label: "Map esistenti",
              icon: Globe2,
              activeCount: Object.values(existingMappingsResult ?? {}).reduce(
                (count, siteResult) =>
                  count + ((siteResult?.mappings || []).length || 0),
                0,
              ),
            },
          ]
        : [
            {
              key: "moda",
              label: "Dati Moda",
              icon: Database,
              activeCount: tabCounts.moda,
              requiredCount: categoryMappingProductMode
                ? requiredCategoryMappingFields.moda.size
                : 0,
            },
            {
              key: "web",
              label: "Dati web chiave",
              icon: Globe2,
              activeCount: tabCounts.web,
              requiredCount: categoryMappingProductMode
                ? requiredCategoryMappingFields.mongo.size
                : 0,
            },
          ]
    : [
        {
          key: "base",
          label: "Dati articolo",
          icon: Hash,
          activeCount: tabCounts.base,
        },
        {
          key: "codici",
          label: "Incolla codici",
          icon: FileText,
          activeCount: tabCounts.codici,
        },
        {
          key: "moda",
          label: "Dati Moda",
          icon: Database,
          activeCount: tabCounts.moda,
        },
        {
          key: "tagModa",
          label: "Tag Moda",
          icon: Tags,
          activeCount: tabCounts.tagModa,
        },
        {
          key: "prezzi",
          label: "Prezzi",
          icon: Payments,
          activeCount: tabCounts.prezzi,
        },
        {
          key: "pubblicazione",
          label: "Stato prestashop",
          icon: FileText,
          activeCount: tabCounts.pubblicazione,
        },
        {
          key: "workflow",
          label: "Workflow pubblicazione",
          icon: Users,
          activeCount: tabCounts.workflow,
        },
        {
          key: "web",
          label: "Dati web",
          icon: Globe2,
          activeCount: tabCounts.web,
        },
        {
          key: "webVig",
          label: "Cat. web VIG",
          icon: Globe2,
          activeCount: tabCounts.webVig,
        },
        {
          key: "webBot",
          label: "Cat. web BOT",
          icon: Globe2,
          activeCount: tabCounts.webBot,
        },
        {
          key: "bot",
          label: "Consolidamento BOT",
          icon: Globe2,
          activeCount: tabCounts.bot,
        },
      ];

  const renderUserSelect = (label, name) => (
    <AdvancedSearchField
      label={label}
      icon={User}
      active={isAdvancedSearchValueActive(localFilters[name])}
    >
      <AdvancedSearchSelect
        name={name}
        value={localFilters[name]}
        onChange={(event) => setField(name, event.target.value)}
      >
        <option value="">Tutti</option>
        {userOptions.map((option) => (
          <option key={option.code} value={option.code}>
            {option.description}
          </option>
        ))}
      </AdvancedSearchSelect>
    </AdvancedSearchField>
  );

  const renderBaseFilters = () => (
    <>
      {[
        ["Codice VS", "codiceVS"],
        ["Codice PS", "idPs"],
        ["Nome", "nome"],
        ["Codice produttore", "codiceProduttore"],
        ["Variante colore", "colore"],
      ].map(([label, name]) => (
        <AdvancedSearchField
          key={name}
          label={label}
          icon={Hash}
          active={isAdvancedSearchValueActive(localFilters[name])}
        >
          <AdvancedSearchTextInput
            name={name}
            value={localFilters[name]}
            onChange={(event) => setField(name, event.target.value)}
          />
        </AdvancedSearchField>
      ))}
      <AdvancedSearchFieldRow>
        <AdvancedSearchField
          label="Stock web >="
          icon={Package}
          active={isAdvancedSearchValueActive(localFilters.stockMin)}
        >
          <AdvancedSearchTextInput
            type="number"
            min={0}
            value={localFilters.stockMin}
            onChange={(event) => setField("stockMin", event.target.value)}
          />
        </AdvancedSearchField>
        <AdvancedSearchField
          label="Stock web <="
          icon={Package}
          active={isAdvancedSearchValueActive(localFilters.stockMax)}
        >
          <AdvancedSearchTextInput
            type="number"
            min={0}
            value={localFilters.stockMax}
            onChange={(event) => setField("stockMax", event.target.value)}
          />
        </AdvancedSearchField>
      </AdvancedSearchFieldRow>
      <AdvancedSearchFieldRow>
        <AdvancedSearchField
          label="Stock moda >="
          icon={Package}
          active={isAdvancedSearchValueActive(localFilters.stockModaMin)}
        >
          <AdvancedSearchTextInput
            type="number"
            min={0}
            value={localFilters.stockModaMin}
            onChange={(event) => setField("stockModaMin", event.target.value)}
          />
        </AdvancedSearchField>
        <AdvancedSearchField
          label="Stock moda <="
          icon={Package}
          active={isAdvancedSearchValueActive(localFilters.stockModaMax)}
        >
          <AdvancedSearchTextInput
            type="number"
            min={0}
            value={localFilters.stockModaMax}
            onChange={(event) => setField("stockModaMax", event.target.value)}
          />
        </AdvancedSearchField>
      </AdvancedSearchFieldRow>
    </>
  );

  const codiciIncollatiText = Array.isArray(localFilters.codiciIncollati)
    ? localFilters.codiciIncollati.join("\n")
    : localFilters.codiciIncollati ?? "";

  const renderCodiciIncollatiFilters = () => (
    <>
      <AdvancedSearchField
        label="Natura del dato"
        icon={Hash}
        active={codiciIncollatiParsed.codes.length > 0}
      >
        <AdvancedSearchSelect
          name="codiciIncollatiTipo"
          aria-label="Natura del dato"
          value={localFilters.codiciIncollatiTipo || CODICI_INCOLLATI_DEFAULT_TIPO}
          onChange={(event) => setField("codiciIncollatiTipo", event.target.value)}
        >
          {CODICI_INCOLLATI_TIPI.map((tipo) => (
            <option key={tipo.value} value={tipo.value}>
              {tipo.label}
            </option>
          ))}
        </AdvancedSearchSelect>
      </AdvancedSearchField>
      <AdvancedSearchField
        label="Codici"
        icon={FileText}
        active={codiciIncollatiParsed.codes.length > 0}
        hint="Separati da virgola, punto e virgola o a capo, con o senza apici; anche colonne copiate da Excel."
      >
        <textarea
          name="codiciIncollati"
          aria-label="Codici da incollare"
          rows={14}
          value={codiciIncollatiText}
          onChange={(event) => setField("codiciIncollati", event.target.value)}
          className="input-reset ba br2 pa2 w-100 code f7"
          style={{
            borderColor: codiciIncollatiParsed.codes.length ? "rgba(19, 119, 82, 0.5)" : "#d1d5db",
            backgroundColor: "#fff",
            resize: "vertical",
          }}
        />
      </AdvancedSearchField>
    </>
  );

  const renderCodiciIncollatiPreview = () => {
    const { codes, duplicati } = codiciIncollatiParsed;
    const tipo = getCodiciIncollatiTipo(localFilters.codiciIncollatiTipo);
    const troppoLungo = isCodiciIncollatiTroppoLungo(codes);
    const anteprima = codes.slice(0, 500);
    return (
      <div>
        <div className="f5 fw6 mb2">Anteprima {tipo.plurale}</div>
        {codes.length ? (
          <>
            <div className="f7 gray lh-copy mb2" aria-live="polite">
              {describeCodiciIncollati(codes, tipo.value)}
              {duplicati > 0 && ` · ${duplicati} duplicati rimossi`}
            </div>
            {troppoLungo && (
              <div role="alert" className="f7 dark-red lh-copy mb2">
                Elenco troppo lungo per una ricerca (massimo {CODICI_INCOLLATI_MAX} codici
                e {CODICI_INCOLLATI_MAX_PARAM_LENGTH.toLocaleString("it-IT")} caratteri dopo la
                pulizia): dividilo in più ricerche.
              </div>
            )}
            <ol
              aria-label="Codici ripuliti"
              className="code f7 pl4 mv0 overflow-auto"
              style={{ maxHeight: "22rem" }}
            >
              {anteprima.map((code) => (
                <li key={code.toUpperCase()}>{code}</li>
              ))}
            </ol>
            {codes.length > anteprima.length && (
              <div className="f7 gray mt2">… e altri {codes.length - anteprima.length}</div>
            )}
          </>
        ) : (
          <div className="f7 gray lh-copy">
            Incolla i codici nella colonna a sinistra: qui compaiono ripuliti da
            separatori, apici e spazi, senza duplicati.
          </div>
        )}
      </div>
    );
  };

  const renderTagModaFilters = () => {
    const state = getLookupState(TAG_MODA_FIELD);
    return (
      <>
        <div className="pa3 mb3 br2 bg-near-white f7 lh-copy gray">
          Tag assegnati all'articolo su Moda (replica giornaliera). Scegli a
          destra se cercare gli articoli che hanno almeno uno dei tag (IN) o
          nessuno di essi (NOT IN).
        </div>
        <AdvancedSearchField
          label={TAG_MODA_FIELD.label}
          icon={Tags}
          active={state.values.length > 0}
          selected
        />
      </>
    );
  };

  const renderTagModaPicker = () => {
    const state = getLookupState(TAG_MODA_FIELD);
    return (
      <AdvancedSearchValuePicker
        label={TAG_MODA_FIELD.label}
        options={multiSelectOptions.tagModa}
        selectedValues={state.values}
        mode={state.mode === "eq" ? "in" : state.mode}
        modes={[
          { key: "in", label: "IN" },
          { key: "not_in", label: "NOT IN" },
        ]}
        onModeChange={(mode, values) => updateLookupValues(TAG_MODA_FIELD, mode, values)}
        onValuesChange={(values) =>
          updateLookupValues(TAG_MODA_FIELD, state.mode === "not_in" ? "not_in" : "in", values)
        }
        tooltip={state.mode === "not_in" ? TAG_MODA_NOT_IN_TOOLTIP : undefined}
      />
    );
  };

  const renderPrezziFilters = () => (
    <>
      {PREZZI_FILTER_FIELDS.map((field) => {
        const disabled = field.riservato && !canReadCosti;
        return (
          <div key={field.min} className="mb2">
            <AdvancedSearchFieldRow>
              {[
                [field.min, ">="],
                [field.max, "<="],
              ].map(([name, operator]) => (
                <AdvancedSearchField
                  key={name}
                  label={`${field.label} ${operator}`}
                  icon={Payments}
                  active={!disabled && isAdvancedSearchValueActive(localFilters[name])}
                >
                  <AdvancedSearchTextInput
                    type="number"
                    step="0.01"
                    name={name}
                    aria-label={`${field.label} ${operator} (${field.unit})`}
                    placeholder={field.unit}
                    disabled={disabled}
                    value={disabled ? "" : localFilters[name]}
                    onChange={(event) => setField(name, event.target.value)}
                    style={disabled ? { backgroundColor: "#f3f4f6", cursor: "not-allowed" } : undefined}
                  />
                </AdvancedSearchField>
              ))}
            </AdvancedSearchFieldRow>
            {disabled && (
              <div className="f7 gray lh-copy ph2">
                Servono i permessi {MODA_ARTICOLI_COSTI_PERMISSION} per utilizzare il filtro.
              </div>
            )}
          </div>
        );
      })}
    </>
  );

  const renderModaFilters = () => (
    <>
      {categoryMappingModaWarning}
      {lookupFields.map((field) => {
        const state = getLookupState(field);
        return (
          <AdvancedSearchField
            key={field.key}
            label={field.label}
            icon={field.icon}
            active={state.values.length > 0}
            required={categoryMappingProductMode && requiredCategoryMappingFields.moda.has(field.key)}
            selected={activeValueKey === field.key}
            onClick={() => setActiveValueKey(field.key)}
          />
        );
      })}

      {!categoryMappingMode && (
        <AdvancedSearchField
          label="Stato Moda"
          icon={Package}
          active={isAdvancedSearchValueActive(localFilters.stato)}
        >
          <AdvancedSearchSelect
            name="stato"
            value={localFilters.stato}
            onChange={(event) => setField("stato", event.target.value)}
          >
            <option value="">Tutti</option>
            <option value="ACTIVE">Attivo</option>
            <option value="INACTIVE">Inattivo</option>
            <option value="ARCHIVED">Archiviato</option>
          </AdvancedSearchSelect>
        </AdvancedSearchField>
      )}
    </>
  );

  const renderPublicationFilters = () => (
    <>
      {[
        ["Visibilita", "visibility", VISIBILITY_OPTIONS],
        [
          "Attivo su e-com (feature)",
          "f_467_attivo_ecom",
          [
            { value: "", label: "Tutti" },
            { value: "SI", label: "SI" },
            { value: "NO", label: "NO" },
          ],
        ],
        ["Effettivamente attivo su Prestashop", "attivo", BOOLEAN_OPTIONS],
      ].map(([label, name, options]) => (
        <AdvancedSearchField
          key={name}
          label={label}
          icon={FileText}
          active={isAdvancedSearchValueActive(localFilters[name])}
        >
          <AdvancedSearchSelect
            value={localFilters[name]}
            onChange={(event) => setField(name, event.target.value)}
          >
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </AdvancedSearchSelect>
        </AdvancedSearchField>
      ))}
      <AdvancedSearchField
        label="Ragioni invisibile/disattivo"
        icon={FileText}
        active={isAdvancedSearchValueActive(localFilters.deactivation_reason)}
      >
        <AdvancedSearchTextInput
          value={localFilters.deactivation_reason}
          onChange={(event) =>
            setField("deactivation_reason", event.target.value)
          }
        />
      </AdvancedSearchField>
    </>
  );

  const renderBotConsolidationFilters = () => (
    <>
      <div className="pa3 mb3 br2 bg-near-white f7 lh-copy gray">
        Lo stato BOT viene aggiornato dall analisi VIG → BOT e diventa Consolidato solo quando le azioni downstream risultano completate. Mai analizzato indica che non esiste ancora una verifica per il prodotto.
      </div>
      {[
        ["Da importare da BOT", "mostra_import_bot"],
        ["Da esportare a BOT", "mostra_export_vig"],
      ].map(([label, name]) => (
        <AdvancedSearchField
          key={name}
          label={label}
          icon={Globe2}
          active={isAdvancedSearchValueActive(localFilters[name])}
        >
          <AdvancedSearchSelect
            name={name}
            value={localFilters[name]}
            onChange={(event) => setField(name, event.target.value)}
          >
            {BOOLEAN_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </AdvancedSearchSelect>
        </AdvancedSearchField>
      ))}
      <AdvancedSearchField
        label="Gruppo articolo VS"
        icon={Database}
        active={isAdvancedSearchValueActive(localFilters.vsArticoliGruppo)}
      >
        <AdvancedSearchSelect
          name="vsArticoliGruppo"
          value={localFilters.vsArticoliGruppo}
          onChange={(event) => setField("vsArticoliGruppo", event.target.value)}
        >
          {VS_ARTICOLI_GRUPPO_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </AdvancedSearchSelect>
      </AdvancedSearchField>
      <AdvancedSearchField
        label="Cat ps BOT al 31/07/2026"
        icon={Tags}
        active={
          isAdvancedSearchValueActive(localFilters.botSnapshotCategory_in) ||
          isAdvancedSearchValueActive(localFilters.botSnapshotCategory_not_in)
        }
      />
      <AdvancedSearchField
        label="Immagine associata 31/07/2026"
        icon={Image}
        active={isAdvancedSearchValueActive(localFilters.botSnapshotHasImage)}
      >
        <AdvancedSearchSelect
          name="botSnapshotHasImage"
          value={localFilters.botSnapshotHasImage}
          onChange={(event) =>
            setField("botSnapshotHasImage", event.target.value)
          }
        >
          <option value="">Tutti</option>
          <option value="1">Sì</option>
          <option value="0">No</option>
        </AdvancedSearchSelect>
      </AdvancedSearchField>
      {[
        ["Dati e testi su Bottero", "botTextConsolidationStatus", FileText],
        ["Immagini su Bottero", "botImageConsolidationStatus", Image],
      ].map(([label, name, Icon]) => (
        <AdvancedSearchField
          key={name}
          label={label}
          icon={Icon}
          active={isAdvancedSearchValueActive(localFilters[name])}
        >
          <AdvancedSearchSelect
            name={name}
            value={localFilters[name]}
            onChange={(event) => setField(name, event.target.value)}
          >
            {BOT_CONSOLIDATION_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </AdvancedSearchSelect>
        </AdvancedSearchField>
      ))}
    </>
  );

  const renderWorkflowFilters = () => (
    <>
      <AdvancedSearchField
        label="Destinazioni"
        icon={Globe2}
        active={
          isAdvancedSearchValueActive(localFilters.destinazioni_in) ||
          isAdvancedSearchValueActive(localFilters.destinazioni_not_in)
        }
        selected
        onClick={() => setActiveValueKey("publicationDestinations")}
        hint="Filtra i siti ai quali Domino deve inviare testi e immagini."
      />
      {[
        ["Pubblicato", "pubblicato", PUBBLICATO_OPTIONS],
        ["Testi importati", "testi_importati", BOOLEAN_OPTIONS],
        ["Ha immagine", "ha_immagine", BOOLEAN_OPTIONS],
        ["Immagine non si trova", "imm_nonsitrova", BOOLEAN_OPTIONS],
        ["Annullato su Moda", "annullato", BOOLEAN_OPTIONS],
        ["Troppe varianti", "troppeVarianti", BOOLEAN_OPTIONS],
      ].map(([label, name, options]) => (
        <AdvancedSearchField
          key={name}
          label={label}
          icon={Image}
          active={isAdvancedSearchValueActive(localFilters[name])}
        >
          <AdvancedSearchSelect
            value={localFilters[name]}
            onChange={(event) => setField(name, event.target.value)}
          >
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </AdvancedSearchSelect>
        </AdvancedSearchField>
      ))}
      <AdvancedSearchFieldRow>
        <AdvancedSearchField
          label="Priorita minima"
          icon={Package}
          active={isAdvancedSearchValueActive(localFilters.priorityMin)}
        >
          <AdvancedSearchTextInput
            type="number"
            value={localFilters.priorityMin}
            onChange={(event) => setField("priorityMin", event.target.value)}
          />
        </AdvancedSearchField>
        <AdvancedSearchField
          label="Priorita massima"
          icon={Package}
          active={isAdvancedSearchValueActive(localFilters.priorityMax)}
        >
          <AdvancedSearchTextInput
            type="number"
            value={localFilters.priorityMax}
            onChange={(event) => setField("priorityMax", event.target.value)}
          />
        </AdvancedSearchField>
      </AdvancedSearchFieldRow>
      <AdvancedSearchFieldRow>
        <AdvancedSearchField
          label="Aggiornato dal"
          icon={Calendar}
          active={isAdvancedSearchValueActive(localFilters.aggiornatoDa)}
        >
          <AdvancedSearchTextInput
            type="date"
            value={localFilters.aggiornatoDa}
            onChange={(event) => setField("aggiornatoDa", event.target.value)}
          />
        </AdvancedSearchField>
        <AdvancedSearchField
          label="Aggiornato al"
          icon={Calendar}
          active={isAdvancedSearchValueActive(localFilters.aggiornatoA)}
        >
          <AdvancedSearchTextInput
            type="date"
            value={localFilters.aggiornatoA}
            onChange={(event) => setField("aggiornatoA", event.target.value)}
          />
        </AdvancedSearchField>
      </AdvancedSearchFieldRow>
      {[
        ["Data import", "importatoDa", "importatoA"],
        ["Data pubblicazione", "pubblicatoDa", "pubblicatoA"],
        ["Data creazione immagini", "immaginiCreateDa", "immaginiCreateA"],
      ].map(([label, fromKey, toKey]) => (
        <AdvancedSearchFieldRow key={fromKey}>
          <AdvancedSearchField
            label={`${label} da`}
            icon={Calendar}
            active={isAdvancedSearchValueActive(localFilters[fromKey])}
          >
            <AdvancedSearchTextInput
              type="date"
              name={fromKey}
              aria-label={`${label} da`}
              value={localFilters[fromKey]}
              max={localFilters[toKey] || undefined}
              onChange={(event) => setField(fromKey, event.target.value)}
            />
          </AdvancedSearchField>
          <AdvancedSearchField
            label={`${label} a`}
            icon={Calendar}
            active={isAdvancedSearchValueActive(localFilters[toKey])}
          >
            <AdvancedSearchTextInput
              type="date"
              name={toKey}
              aria-label={`${label} a`}
              value={localFilters[toKey]}
              min={localFilters[fromKey] || undefined}
              onChange={(event) => setField(toKey, event.target.value)}
            />
          </AdvancedSearchField>
        </AdvancedSearchFieldRow>
      ))}
      {renderUserSelect("Assegnato a", "assignedTo")}
      <AdvancedSearchField label="Import registrato" icon={Database} active={isAdvancedSearchValueActive(localFilters.importRegistrato)}>
        <AdvancedSearchSelect name="importRegistrato" value={localFilters.importRegistrato} onChange={(event) => setField("importRegistrato", event.target.value)}>
          {BOOLEAN_OPTIONS.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
        </AdvancedSearchSelect>
      </AdvancedSearchField>
      {renderUserSelect("Ultimo import da", "ut_import_done")}
      {renderUserSelect("Testi fatti da", "ut_pubbl_done")}
      {renderUserSelect("Testi assegnati a", "ut_pubbl_pren")}
      {renderUserSelect("Immagini fatte da", "ut_imm_done")}
      {renderUserSelect("Immagini assegnate a", "ut_imm_pren")}
      {renderUserSelect("Richiesta pubbl. da", "ut_richiede")}
    </>
  );

  const renderWebFilters = () => (
    <>
      {activeMongoSelectConfig.map((field) => {
        const state = getMongoSelectState(field);
        return (
          <AdvancedSearchField
            key={field.key}
            label={field.label}
            icon={Tags}
            active={state.values.length > 0}
            required={categoryMappingProductMode && requiredCategoryMappingFields.mongo.has(field.key)}
            selected={activeValueKey === `mongo:${field.key}`}
            onClick={() => setActiveValueKey(`mongo:${field.key}`)}
          />
        );
      })}
    </>
  );

  const renderCategoryFilters = (site) => (
    <>
      {CATEGORY_VALUE_FILTERS_BY_SITE[site].map((field) => (
        <AdvancedSearchField
          key={field.key}
          label={field.label}
          icon={field.icon}
          active={isAdvancedSearchValueActive(
            localFilters.mongoFilters?.[field.includeKey],
          )}
          selected={activeValueKey === field.key}
          onClick={() => setActiveValueKey(field.key)}
          hint={activeValueKey === field.key ? field.help : undefined}
        />
      ))}
    </>
  );

  const renderFilterColumn = () => {
    if (activeTab === "moda") return renderModaFilters();
    if (activeTab === "codici") return renderCodiciIncollatiFilters();
    if (activeTab === "tagModa") return renderTagModaFilters();
    if (activeTab === "prezzi") return renderPrezziFilters();
    if (activeTab === "pubblicazione") return renderPublicationFilters();
    if (activeTab === "bot") return renderBotConsolidationFilters();
    if (activeTab === "workflow") return renderWorkflowFilters();
    if (activeTab === "web") return renderWebFilters();
    if (activeTab === "webVig") return renderCategoryFilters("VIG");
    if (activeTab === "webBot") return renderCategoryFilters("BOT");
    return renderBaseFilters();
  };

  const renderValueColumn = () => {
    if (activeTab === "codici") return renderCodiciIncollatiPreview();
    if (activeTab === "tagModa") return renderTagModaPicker();
    if (activeTab === "prezzi") {
      return (
        <div className="f7 gray lh-copy">
          <div className="f5 fw6 mb2 near-black">Prezzi WEB</div>
          <p className="mt0">
            Valori del listino WEB attivo oggi (variante 1, taglia 1, non
            annullato). Gli articoli senza listino WEB attivo non rientrano in
            questi filtri.
          </p>
          <p>Percentuale sconto: (cartellino − scontato) / cartellino × 100.</p>
          <p className="mb0">
            Margine: (prezzo / 1,22 − costo acquisto medio) / (prezzo / 1,22) ×
            100, sul prezzo IVA 22% scorporata. Costo e margini richiedono{" "}
            {MODA_ARTICOLI_COSTI_PERMISSION}.
          </p>
        </div>
      );
    }

    if (activeTab === "workflow") {
      const state = getPublicationDestinationState();
      return (
        <AdvancedSearchValuePicker
          label="Destinazioni"
          options={PUBLICATION_DESTINATION_OPTIONS}
          selectedValues={state.values}
          mode={state.mode}
          modes={[
            { key: "in", label: "IN" },
            { key: "not_in", label: "NOT IN" },
          ]}
          onModeChange={(mode, values) =>
            updatePublicationDestinationValues(mode, values)
          }
          onValuesChange={(values) =>
            updatePublicationDestinationValues(state.mode, values)
          }
          tooltip={
            state.mode === "not_in"
              ? PUBLICATION_DESTINATION_NOT_IN_TOOLTIP
              : undefined
          }
        />
      );
    }

    if (activeTab === "moda") {
      const field =
        lookupFields.find((item) => item.key === activeValueKey) ??
        lookupFields[0];
      const state = getLookupState(field);
      return (
        <AdvancedSearchValuePicker
          label={field.label}
          options={multiSelectOptions[field.key] ?? []}
          selectedValues={state.values}
          mode={state.mode}
          modes={categoryMappingProductMode ? [{ key: "eq", label: "=" }] : undefined}
          onModeChange={(mode, values) =>
            updateLookupValues(field, mode, values)
          }
          onValuesChange={(values) =>
            updateLookupValues(field, state.mode, values)
          }
          tooltip={state.mode === "not_in" ? SQL_NOT_IN_TOOLTIP : undefined}
          disabled={categoryMappingMode && categoryMappingInputLocked}
        />
      );
    }

    if (activeTab === "bot") {
      const state = getBotSnapshotCategoryState();
      return (
        <AdvancedSearchValuePicker
          label="Cat ps BOT al 31/07/2026"
          options={lookupOptions?.botSnapshotCategory ?? []}
          selectedValues={state.values}
          mode={state.mode}
          modes={[
            { key: "in", label: "IN" },
            { key: "not_in", label: "NOT IN" },
          ]}
          onModeChange={(mode, values) =>
            updateBotSnapshotCategoryValues(mode, values)
          }
          onValuesChange={(values) =>
            updateBotSnapshotCategoryValues(state.mode, values)
          }
          tooltip={state.mode === "not_in" ? SQL_NOT_IN_TOOLTIP : undefined}
        />
      );
    }

    if (["web", "webVig", "webBot"].includes(activeTab)) {
      const categorySite =
        activeTab === "webVig" ? "VIG" : activeTab === "webBot" ? "BOT" : null;
      const categoryFields = categorySite
        ? CATEGORY_VALUE_FILTERS_BY_SITE[categorySite]
        : [];
      const categoryField = categorySite
        ? categoryFields.find((item) => item.key === activeValueKey) ??
          categoryFields[0]
        : null;
      if (categoryField) {
        const activeValues = Array.isArray(
          localFilters.mongoFilters?.[categoryField.includeKey],
        )
          ? localFilters.mongoFilters[categoryField.includeKey]
          : [];
        const isAssociatedCategoryField =
          categoryField.key === "categorieWeb" ||
          categoryField.key === "categorieWebBottero";
        const currentMode =
          localFilters.mongoFilters?.[categoryField.modeKey] ??
          (isAssociatedCategoryField ? "any" : "none");
        return (
          <div>
            <div className="f5 fw6 mb2">{categoryField.label}</div>
            <div className="f7 gray lh-copy mb3">{categoryField.help}</div>
            {categoryField.modeKey && (
              <div className="flex flex-wrap mb3">
                {(isAssociatedCategoryField
                  ? [
                      { key: "any", label: "ALMENO UNA" },
                      { key: "all", label: "TUTTE" },
                    ]
                  : [
                      { key: "missing_any", label: "NE MANCA ALMENO UNA" },
                      { key: "none", label: "TUTTE ASSENTI" },
                    ]
                ).map((mode) => (
                  <button
                    key={mode.key}
                    type="button"
                    className="button-reset ba br2 pointer mr2 mb2 pv1 ph2 f7"
                    style={{
                      borderColor:
                        currentMode === mode.key
                          ? "var(--colTastoVerde, #137752)"
                          : "#d1d5db",
                      backgroundColor:
                        currentMode === mode.key
                          ? "rgba(19, 119, 82, 0.12)"
                          : "#fff",
                    }}
                    onClick={() => updateCategoryMode(categoryField, mode.key)}
                  >
                    {mode.label}
                  </button>
                ))}
              </div>
            )}
            <CategorieWebSub
              onChange={(node, selectedNodes) =>
                updateCategoryValues(categoryField, selectedNodes)
              }
              data={categoryTreesBySite[categorySite] || []}
              categorie={activeValues}
            />
          </div>
        );
      }

      const mongoKey = String(activeValueKey).replace(/^mongo:/, "");
      const field =
        activeMongoSelectConfig.find((item) => item.key === mongoKey) ??
        activeMongoSelectConfig[0];
      if (field) {
        const state = getMongoSelectState(field);
        return (
          <AdvancedSearchValuePicker
            label={field.label}
            options={(field.options ?? []).map((option) => ({
              code: option.idPS ?? option.value,
              description: option.label ?? option.desc,
            }))}
            selectedValues={state.values}
            mode={state.mode}
            modes={categoryMappingProductMode
              ? [{ key: "eq", label: "=" }]
              : [
                  { key: "in", label: "IN" },
                  { key: "not_in", label: "NOT IN" },
                ]}
            onModeChange={(mode, values) =>
              updateMongoSelectValues(field, mode, values)
            }
            onValuesChange={(values) =>
              updateMongoSelectValues(field, state.mode, values)
            }
            tooltip={state.mode === "not_in" ? MONGO_NOT_IN_TOOLTIP : undefined}
            disabled={categoryMappingMode && categoryMappingInputLocked}
          />
        );
      }
    }

    return null;
  };

  const toggleCategoryMappingOutput = (site, value) => {
    const stringValue = String(value);
    setCategoryMappingOutputs((prev) => {
      const current = prev?.[site] || [];
      const isRemoving = current.includes(stringValue);
      const nextValues = isRemoving
        ? current.filter((item) => item !== stringValue)
        : [...current, stringValue];
      setCategoryMappingDefaultOutputs((defaultPrev) => {
        const currentDefault = defaultPrev?.[site] || "";
        if (isRemoving && currentDefault === stringValue) {
          return { ...defaultPrev, [site]: nextValues[0] || "" };
        }
        if (!isRemoving && !currentDefault) {
          return { ...defaultPrev, [site]: stringValue };
        }
        return defaultPrev;
      });
      return { ...normalizeCategoryMappingOutputs(prev), [site]: nextValues };
    });
  };

  const setCategoryMappingDefaultOutput = (site, value) => {
    const stringValue = String(value);
    const selectedValues = categoryMappingOutputs?.[site] || [];
    if (!selectedValues.includes(stringValue)) return;
    setCategoryMappingDefaultOutputs((prev) => ({
      ...prev,
      [site]: stringValue,
    }));
  };

  const getSiteCategories = (site) =>
    [...(siteCategories?.[site] || [])].sort((a, b) =>
      siteCategoryLabel(a).localeCompare(siteCategoryLabel(b)),
    );

  const buildSiteCategoryTree = (categories) => {
    const nodesById = new Map();
    const parentById = new Map();
    categories.forEach((category) => {
      const value = siteCategoryValue(category);
      if (!value) return;
      nodesById.set(value, { ...category, value, children: [] });
      const parentValue =
        category?.parent_external_id === undefined ||
        category?.parent_external_id === null ||
        category?.parent_external_id === ""
          ? ""
          : String(category.parent_external_id);
      parentById.set(value, parentValue);
    });

    const roots = [];
    nodesById.forEach((node, value) => {
      const parentValue = parentById.get(value);
      const parentNode = parentValue ? nodesById.get(parentValue) : null;
      if (parentNode && parentNode !== node) {
        parentNode.children.push(node);
      } else {
        roots.push(node);
      }
    });

    const sortNodes = (nodes) => {
      nodes.sort((a, b) =>
        String(a.path || a.label || a.value).localeCompare(
          String(b.path || b.label || b.value),
          "it",
        ),
      );
      nodes.forEach((node) => sortNodes(node.children));
      return nodes;
    };

    return sortNodes(roots);
  };

  const filterCategoryTree = (nodes, searchTerm) => {
    if (!searchTerm) return nodes;
    return nodes
      .map((node) => {
        const children = filterCategoryTree(node.children || [], searchTerm);
        const haystack =
          `${siteCategoryValue(node)} ${siteCategoryLabel(node)} ${node.path || ""}`.toLowerCase();
        if (haystack.includes(searchTerm) || children.length) {
          return { ...node, children };
        }
        return null;
      })
      .filter(Boolean);
  };

  const hideHomeRootCategory = (nodes) => {
    const normalizedHomeLabel = (node) =>
      String(node?.label || node?.path || "")
        .trim()
        .toLowerCase();
    return nodes.flatMap((node) => {
      const value = siteCategoryValue(node);
      const label = normalizedHomeLabel(node);
      const isHomeRoot =
        (!node.parent_external_id || Number(node.parent_external_id) === 0) &&
        (label === "home" || value === "1" || value === "2");
      return isHomeRoot && Array.isArray(node.children) && node.children.length
        ? node.children
        : [node];
    });
  };

  const collectExpandedCategoryIds = (nodes, result = []) => {
    nodes.forEach((node) => {
      if (Array.isArray(node.children) && node.children.length) {
        result.push(siteCategoryValue(node));
        collectExpandedCategoryIds(node.children, result);
      }
    });
    return result;
  };

  const toggleCategoryTreeNode = (site, value) => {
    setCategoryTreeExpandedBySite((prev) => {
      const current = new Set(prev?.[site] || []);
      const stringValue = String(value);
      if (current.has(stringValue)) {
        current.delete(stringValue);
      } else {
        current.add(stringValue);
      }
      return { ...prev, [site]: Array.from(current) };
    });
  };

  const getSelectedSiteCategories = (site) => {
    const categories = getSiteCategories(site);
    const byValue = new Map(
      categories.map((category) => [siteCategoryValue(category), category]),
    );
    const defaultValue = categoryMappingDefaultOutputs?.[site] || "";
    return (categoryMappingOutputs[site] || []).map((value) => ({
      value,
      category: byValue.get(String(value)),
      isDefault: String(value) === String(defaultValue),
    }));
  };

  const renderCategoryMappingTreeNodes = (
    nodes,
    expandedValues,
    selectedValues,
    depth = 0,
  ) =>
    nodes.map((category) => {
      const value = siteCategoryValue(category);
      const checked = selectedValues.includes(value);
      const children = Array.isArray(category.children)
        ? category.children
        : [];
      const hasChildren = children.length > 0;
      const expanded = expandedValues.has(value);
      return (
        <div key={activeMappingSite + "-" + value}>
          <div
            className="flex items-start justify-between pa2 bb b--black-05"
            style={{
              backgroundColor: checked ? "rgba(19, 119, 82, 0.08)" : undefined,
              paddingLeft: `${0.5 + depth * 1.15}rem`,
            }}
          >
            <div className="flex items-start pr2 flex-auto">
              <button
                type="button"
                className={`button-reset bn pointer mr2 flex items-center justify-center scrittaColAltScuro ${!hasChildren ? "o-0" : ""}`}
                style={{
                  color: hasChildren ? undefined : "transparent",
                  lineHeight: 1,
                  fontSize: "1.75rem",
                  padding: 0,
                  background: "transparent",
                  border: "none",
                }}
                onClick={() =>
                  hasChildren &&
                  toggleCategoryTreeNode(activeMappingSite, value)
                }
                disabled={!hasChildren}
                title={expanded ? "Comprimi" : "Espandi"}
              >
                {hasChildren ? (expanded ? "▾" : "▸") : "·"}
              </button>
              <button
                type="button"
                className="button-reset bg-transparent bn tl pointer flex-auto pa0"
                onClick={() =>
                  toggleCategoryMappingOutput(activeMappingSite, value)
                }
              >
                <span className="db f7 b">{category.label || value}</span>
                <span className="db f7 gray lh-copy">
                  {category.path || siteCategoryLabel(category)}
                </span>
                <span className="db f7 gray">{value}</span>
              </button>
            </div>
            <input
              type="checkbox"
              checked={checked}
              onChange={() =>
                toggleCategoryMappingOutput(activeMappingSite, value)
              }
            />
          </div>
          {hasChildren &&
            expanded &&
            renderCategoryMappingTreeNodes(
              children,
              expandedValues,
              selectedValues,
              depth + 1,
            )}
        </div>
      );
    });

  const renderCategoryMappingCategoryList = () => {
    const selectedValues = categoryMappingOutputs[activeMappingSite] || [];
    const searchTerm = categorySearch.trim().toLowerCase();
    const categories = getSiteCategories(activeMappingSite);
    const tree = hideHomeRootCategory(buildSiteCategoryTree(categories));
    const filteredTree = filterCategoryTree(tree, searchTerm);
    const expandedValues = new Set(
      searchTerm
        ? collectExpandedCategoryIds(filteredTree)
        : categoryTreeExpandedBySite[activeMappingSite] || [],
    );
    const activeSiteLabel = CATEGORY_MAPPING_SITES.find(
      (site) => site.key === activeMappingSite,
    )?.label;

    return (
      <div className="h-100 flex flex-column" style={{ minHeight: 0 }}>
        <div className="flex-shrink-0 mb3">
          <div className="f5 fw6 mb1">Categorie {activeSiteLabel}</div>
          <div className="f7 gray lh-copy mb2">
            Seleziona le categorie output da associare alla combinazione di
            filtri.
          </div>
          <input
            value={categorySearch}
            onChange={(event) => setCategorySearch(event.target.value)}
            className="input-reset ba b--silver br2 pa2 w-75"
            placeholder="Filtra categorie"
          />
        </div>
        <div
          className="overflow-auto ba b--black-10 br2 flex-auto"
          style={{ minHeight: 0 }}
        >
          {filteredTree.length === 0 ? (
            <div className="pa3 f7 gray">Nessuna categoria disponibile.</div>
          ) : (
            renderCategoryMappingTreeNodes(
              filteredTree,
              expandedValues,
              selectedValues,
            )
          )}
        </div>
      </div>
    );
  };

  const renderCategoryMappingPreview = () => (
    <div>
      <div className="f5 fw6 mb3">Anteprima mappatura</div>
      <div className="mb3 pa3 br2 ba b--black-10">
        <label className="db f7 ttu tracked gray mb1" htmlFor="category-mapping-name">
          Nome mappatura
        </label>
        <input
          id="category-mapping-name"
          className="input-reset ba b--silver br2 pa2 w-100"
          value={categoryMappingName}
          onChange={(event) => setCategoryMappingName(event.target.value)}
          placeholder="Nome mappatura"
        />
      </div>
      <div className="mb3 pa3 br2 ba b--black-10">
        <div className="f7 ttu tracked gray mb2">Filtri input</div>
        {summaryEntries.length === 0 ? (
          <div className="f7 gray lh-copy">Nessun filtro MODA valorizzato.</div>
        ) : (
          <div className="flex flex-wrap">
            {summaryEntries.map(([label, value], index) => (
              <div
                key={label + "-" + index}
                className="mr2 mb2 pa2 br2"
                style={{ backgroundColor: "rgba(19, 119, 82, 0.08)" }}
              >
                <div className="f7 ttu tracked gray">{label}</div>
                <div
                  className="f6 b lh-copy"
                  style={{ wordBreak: "break-word" }}
                >
                  {value}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {CATEGORY_MAPPING_SITES.map((site) => {
        const selected = getSelectedSiteCategories(site.key);
        return (
          <div key={site.key} className="mb3 pa3 br2 ba b--black-10">
            <div className="flex items-center justify-between mb2">
              <div className="f6 fw6">{site.label}</div>
              <div
                className="br-pill ph2 pv1 f7 white"
                style={{ backgroundColor: "var(--colTastoVerde, #137752)" }}
              >
                {selected.length}
              </div>
            </div>
            {selected.length === 0 ? (
              <div className="f7 gray lh-copy">
                Nessuna categoria selezionata.
              </div>
            ) : (
              <div className="flex flex-column">
                {selected.map(({ value, category, isDefault }) => (
                  <div
                    key={site.key + "-preview-" + value}
                    className="mb2 pa2 br2"
                    style={{
                      backgroundColor: isDefault
                        ? "rgba(19, 119, 82, 0.16)"
                        : "rgba(19, 119, 82, 0.08)",
                    }}
                  >
                    <div className="flex items-start justify-between">
                      <div className="pr2">
                        <div className="f7 b">{category?.label || value}</div>
                        <div className="f7 gray lh-copy">
                          {category?.path || siteCategoryLabel(category) || value}
                        </div>
                        <div className="f7 gray">{value}</div>
                      </div>
                      <label className="f7 nowrap pointer flex items-center">
                        <input
                          type="radio"
                          className="mr1"
                          name={`category-default-${site.key}`}
                          checked={isDefault}
                          onChange={() =>
                            setCategoryMappingDefaultOutput(site.key, value)
                          }
                        />
                        Default
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );

  const renderExistingMappingsFilterSummary = () => (
    <div>
      <div className="f5 fw6 mb3">Filtri attuali</div>
      {categoryMappingModaWarning}
      {summaryEntries.length === 0 ? (
        <div className="pa3 br2 ba b--black-10 gray lh-copy">
          Nessun filtro valorizzato.
        </div>
      ) : (
        summaryEntries.map(([label, value], index) => (
          <div
            key={label + "-existing-filter-" + index}
            className="mb2 pa2 br2"
            style={{ backgroundColor: "rgba(19, 119, 82, 0.08)" }}
          >
            <div className="f7 ttu tracked gray">{label}</div>
            <div className="f6 b lh-copy" style={{ wordBreak: "break-word" }}>
              {value}
            </div>
          </div>
        ))
      )}
    </div>
  );

  const renderExistingMappings = () => {
    const siteEntries = CATEGORY_MAPPING_SITES.map((site) => ({
      ...site,
      result: existingMappingsResult?.[site.key],
    }));
    const totalMappings = siteEntries.reduce(
      (count, site) => count + ((site.result?.mappings || []).length || 0),
      0,
    );
    return (
      <div>
        <div className="flex items-center justify-between mb3">
          <div>
            <div className="f5 fw6">Map esistenti applicabili</div>
            <div className="f7 gray lh-copy">
              Risultati calcolati sui valori attualmente impostati nel modale.
            </div>
          </div>
          <button
            type="button"
            className="button-reset ba br2 pointer pv1 ph2 f7"
            onClick={() => setExistingMappingsReloadKey((prev) => prev + 1)}
          >
            Aggiorna
          </button>
        </div>
        {existingMappingsLoading ? (
          <div className="pa3 br2 ba b--black-10 gray">
            Carico map esistenti...
          </div>
        ) : existingMappingsError ? (
          <div className="pa3 br2 ba b--red dark-red">
            {existingMappingsError}
          </div>
        ) : totalMappings === 0 ? (
          <div className="pa3 br2 ba b--black-10 gray lh-copy">
            Nessuna mappatura applicabile ai filtri attuali.
          </div>
        ) : (
          siteEntries.map((site) => {
            const mappings = site.result?.mappings || [];
            const groupedMappings = groupResolvedCategoryMappings(mappings);
            return (
              <div key={site.key} className="mb3 pa3 br2 ba b--black-10">
                <div className="flex items-center justify-between mb2">
                  <div className="f6 fw6">{site.label}</div>
                  <div
                    className="br-pill ph2 pv1 f7 white"
                    style={{ backgroundColor: "var(--colTastoVerde, #137752)" }}
                  >
                    {groupedMappings.length}
                  </div>
                </div>
                {groupedMappings.length === 0 ? (
                  <div className="f7 gray lh-copy">
                    Nessuna mappatura per questo sito.
                  </div>
                ) : (
                  groupedMappings.map((mapping) => {
                    const defaultCategoryId =
                      getDefaultCategoryFromMappingGroup(mapping);
                    const categoryIds = mapping.categories.map(
                      (category) => category.categoryId,
                    );
                    return (
                      <div
                        key={`${site.key}-${mapping.key}`}
                        className="mb2 pa2 br2"
                        style={{ backgroundColor: "rgba(19, 119, 82, 0.08)" }}
                      >
                        <div className="flex items-start justify-between">
                          <div className="pr2">
                            <div className="f7 ttu tracked gray">
                              Regola {mapping.ruleId}
                              {mapping.ruleKey ? ` - ${mapping.ruleKey}` : ""}
                            </div>
                            <div className="f6 b lh-copy">
                              {mapping.ruleDescription || "Senza descrizione"}
                            </div>
                          </div>
                          <div className="flex items-center">
                            <UserAvatarBadge
                              username={mapping.updatedBy}
                              fallbackUsername={mapping.createdBy}
                              size={26}
                            />
                            {typeof onApplyExistingMapping === "function" && (
                            <button
                              type="button"
                              className="button-reset ba br2 pointer pv1 ph2 f7 ml2"
                              onClick={() =>
                                onApplyExistingMapping(
                                  site.key,
                                  categoryIds,
                                  defaultCategoryId,
                                )
                              }
                            >
                              Applica
                            </button>
                            )}
                          </div>
                        </div>
                        <div className="mt2 flex flex-wrap">
                          {mapping.categories.map((category) => (
                            <span
                              key={`${mapping.key}-${category.categoryId}`}
                              className="br-pill ph2 pv1 mr2 mb2 f7"
                              style={{
                                backgroundColor: category.isDefaultCandidate
                                  ? "var(--colTastoVerde, #137752)"
                                  : "rgba(255, 255, 255, 0.72)",
                                color: category.isDefaultCandidate
                                  ? "#fff"
                                  : "inherit",
                              }}
                            >
                              {category.categoryPath ||
                                category.categoryLabel ||
                                category.categoryId}
                              {category.isDefaultCandidate ? " - default" : ""}
                            </span>
                          ))}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            );
          })
        )}
      </div>
    );
  };

  const availableMappingCounts = CATEGORY_MAPPING_SITES.reduce(
    (counts, site) => {
      counts[site.key] = groupResolvedCategoryMappings(
        existingMappingsResult?.[site.key]?.mappings,
      ).length;
      return counts;
    },
    { VIG: 0, BOT: 0 },
  );
  const totalAvailableMappings =
    availableMappingCounts.VIG + availableMappingCounts.BOT;
  const hasMissingMappingRequirements = categoryMappingRequirements.some(
    (requirement) =>
      requirement.requiresInput ||
      (requirement.missingRequirements || []).length > 0,
  );

  const renderCategoryMappingPanelButton = (key, label) => {
    const selected = categoryMappingPanel === key;
    return (
      <button
        key={key}
        type="button"
        className="button-reset pointer pv2 ph3 f6 ba b--black-10 br2 flex-shrink-0"
        style={{
          backgroundColor: selected
            ? "var(--colTastoVerde, #137752)"
            : "#fff",
          color: selected ? "#fff" : "inherit",
        }}
        onClick={() => {
          setCategoryMappingPanel(key);
          if (key === "filters") {
            setActiveTab("moda");
            setActiveValueKey((prev) =>
              lookupFields.some((field) => field.key === prev)
                ? prev
                : "reparto",
            );
          } else if (key === "mapping") {
            setActiveMappingSite((prev) => prev || "VIG");
            setCategorySearch("");
            if (!categoryMappingInputLocked) {
              resolveExistingMappingsForFilters(localFilters).catch(() => {});
            }
          } else {
            setExistingMappingsReloadKey((prev) => prev + 1);
          }
        }}
      >
        {label}
      </button>
    );
  };

  const mappingAvailabilityMessage =
    existingMappingsLoading || existingMappingsResult === null
    ? "Aggiornamento mappature..."
    : existingMappingsError
      ? "Errore nel recupero delle mappature"
      : hasMissingMappingRequirements
        ? "Sono necessari alcuni dati in piu per mappare questo articolo"
        : totalAvailableMappings === 0
          ? "Non esistono mappature per questi valori"
          : "Mappature applicabili ai valori correnti";
  const showMissingRequirementsMessage =
    !existingMappingsLoading &&
    existingMappingsResult !== null &&
    !existingMappingsError &&
    hasMissingMappingRequirements;

  const categoryMappingFooterSwitch = categoryMappingMode ? (
    categoryMappingProductMode ? (
      <div className="w-100 flex items-center justify-center">
        {renderCategoryMappingPanelButton("existing", "Map applicabili")}
        <div className="ph3 tc flex-auto" style={{ minWidth: "22rem" }}>
          <div className="f7 ttu tracked gray mb1">Map disponibili</div>
          <div className="flex items-center justify-center">
            <span className="f7 fw6 mr1">VIG</span>
            <span
              className="dib br-100 white tc fw6 mr3"
              style={{
                width: "24px",
                height: "24px",
                lineHeight: "24px",
                backgroundColor: "#2563eb",
              }}
              title="Mappature disponibili per VIG"
            >
              {availableMappingCounts.VIG}
            </span>
            <span className="f7 fw6 mr1">BOT</span>
            <span
              className="dib br-100 white tc fw6"
              style={{
                width: "24px",
                height: "24px",
                lineHeight: "24px",
                backgroundColor: "#dc2626",
              }}
              title="Mappature disponibili per BOT"
            >
              {availableMappingCounts.BOT}
            </span>
          </div>
          <div
            className={
              "f7 mt1 " +
              (existingMappingsError
                ? "dark-red"
                : showMissingRequirementsMessage
                  ? "dark-red fw6"
                  : "gray")
            }
          >
            {mappingAvailabilityMessage}
          </div>
        </div>
        {renderCategoryMappingPanelButton("filters", "Dati da completare")}
      </div>
    ) : (
      <div className="flex items-center">
        {[
          ["existing", "Map esistenti"],
          ["filters", "Filtri"],
          ["mapping", "Mappatura"],
        ].map(([key, label]) => renderCategoryMappingPanelButton(key, label))}
      </div>
    )
  ) : null;

  const handleRemoveSummaryEntry = (removeKey) => {
    if (typeof removeKey !== "string") return;
    if (removeKey.startsWith("mongo:")) {
      const key = removeKey.slice("mongo:".length);
      setMongoFilters((prev) => {
        const next = { ...prev };
        delete next[key];
        if (key.endsWith("_in")) {
          delete next[key.slice(0, -3) + "_in_match"];
        }
        if (key.endsWith("_not_in")) {
          delete next[key.slice(0, -7) + "_not_in_match"];
        }
        return next;
      });
      return;
    }
    if (removeKey.startsWith("input:")) {
      const key = removeKey.slice("input:".length);
      const defaults = buildDefaultFilters();
      updateLocalFilters((prev) => {
        const next = { ...prev };
        if (Object.prototype.hasOwnProperty.call(defaults, key)) {
          next[key] = Array.isArray(defaults[key])
            ? [...defaults[key]]
            : defaults[key];
        } else {
          delete next[key];
        }
        return next;
      });
    }
  };

  const handleReset = () => {
    updateLocalFilters(buildDefaultFilters());
    setActiveTab(categoryMappingMode ? "moda" : "base");
    setActiveValueKey(categoryMappingMode ? "reparto" : "brand");
    setValuePickerModes({});
    if (categoryMappingMode) {
      setCategoryMappingOutputs({ VIG: [], BOT: [] });
      setCategoryMappingDefaultOutputs({ VIG: "", BOT: "" });
      setCategoryMappingPanel(initialMappingPanel);
      setCategorySearch("");
      setActiveMappingSite("VIG");
      setExistingMappingsError("");
      setExistingMappingsResult(null);
      setExistingMappingsReloadKey((prev) => prev + 1);
    }
  };

  const persistDirtyFilters = (force = false) => {
    if (
      categoryMappingMode &&
      filtersDirty &&
      typeof onFiltersChange === "function" &&
      (persistFiltersOnChange || force)
    ) {
      onFiltersChange(cleanEntries(localFilters));
    }
  };

  const handleClose = () => {
    persistDirtyFilters();
    onClose();
  };

  const handleSubmit = async () => {
    if (categoryMappingProductMode) {
      persistDirtyFilters(true);
      onApply({ filters: cleanEntries(localFilters) });
      setFiltersDirty(false);
      return;
    }
    let mappingName = categoryMappingName.trim();
    if (categoryMappingMode && !categoryMappingInputLocked) {
      try {
        const resolvedMappings = await resolveExistingMappingsForFilters(
          localFilters,
        );
        const exactMapping = findExactResolvedMapping(
          resolvedMappings,
          localFilters,
          editingCategoryMappingRuleId,
        );
        if (exactMapping) {
          setCategoryMappingPanel("existing");
          setExistingMappingsResult(resolvedMappings ?? null);
          window.alert(
            `Esiste gia' una mappatura con gli stessi requisiti (${exactMapping.ruleDescription || `regola ${exactMapping.ruleId}`}). Le map solo compatibili ma meno specifiche non bloccano il salvataggio.`,
          );
          return;
        }
      } catch (_error) {
        setCategoryMappingPanel("existing");
        return;
      }
    }
    if (categoryMappingMode && !mappingName) {
      const requestedName = window.prompt("Nome mappatura");
      if (requestedName === null) return;
      mappingName = requestedName.trim();
      if (!mappingName) {
        window.alert("Il nome della mappatura e' obbligatorio.");
        return;
      }
      setCategoryMappingName(mappingName);
    }
    if (
      !categoryMappingMode &&
      isCodiciIncollatiTroppoLungo(codiciIncollatiParsed.codes)
    ) {
      // L'avviso è nell'anteprima della tab: lì l'utente vede cosa ridurre.
      setActiveTab("codici");
      return;
    }
    persistDirtyFilters(true);
    onApply(
      categoryMappingMode
        ? {
            categoryMappingName: mappingName,
            filters: cleanEntries(localFilters),
            categoryOutputs: normalizeCategoryMappingOutputs(
              categoryMappingOutputs,
            ),
            categoryDefaultOutputs: normalizeCategoryMappingDefaultOutputs(
              categoryMappingDefaultOutputs,
              categoryMappingOutputs,
            ),
          }
        : withoutPrezziRiservati(
            cleanEntries(normalizeCodiciIncollatiFilters(localFilters)),
            canReadCosti,
          ),
    );
    onClose();
  };

  const layout = (
    <AdvancedSearchLayout
      title={categoryMappingMode ? categoryMappingTitle : "Filtri avanzati MODA articoli"}
      tabs={tabs}
      activeTab={
        categoryMappingMode && categoryMappingPanel === "mapping"
          ? activeMappingSite
          : categoryMappingMode && categoryMappingPanel === "existing"
            ? "existing"
            : activeTab
      }
      onTabChange={
        categoryMappingMode && categoryMappingPanel === "mapping"
          ? (site) => {
              setActiveMappingSite(site);
              setCategorySearch("");
            }
          : categoryMappingMode && categoryMappingPanel === "existing"
            ? () => {}
            : setActiveTab
      }
      filterColumn={
        categoryMappingMode && categoryMappingPanel === "mapping"
          ? renderCategoryMappingCategoryList()
          : categoryMappingMode && categoryMappingPanel === "existing"
            ? renderExistingMappingsFilterSummary()
            : renderFilterColumn()
      }
      valueColumn={
        categoryMappingMode && categoryMappingPanel === "mapping"
          ? renderCategoryMappingPreview()
          : categoryMappingMode && categoryMappingPanel === "existing"
            ? renderExistingMappings()
            : renderValueColumn()
      }
      valueColumnWide={
        categoryMappingMode &&
        (categoryMappingPanel === "mapping" || categoryMappingPanel === "existing")
      }
      showSummaryColumn={
        !categoryMappingMode ||
        (categoryMappingPanel !== "mapping" && categoryMappingPanel !== "existing")
      }
      summaryEntries={summaryEntries}
      summaryExtra={null}
      footerCenter={categoryMappingFooterSwitch}
      footerLeftExtra={
        categoryMappingMode && typeof onDeleteCategoryMapping === "function" ? (
          <button
            type="button"
            className="dim tastoInputOrizzontale br3 mr2 inline-flex items-center"
            style={{ backgroundColor: "#b91c1c", color: "#fff" }}
            onClick={onDeleteCategoryMapping}
          >
            Elimina
          </button>
        ) : null
      }
      onRemoveSummaryEntry={
        categoryMappingMode && categoryMappingInputLocked
          ? undefined
          : handleRemoveSummaryEntry
      }
      onClose={categoryMappingProductMode ? undefined : handleClose}
      onReset={
        categoryMappingProductMode || (categoryMappingMode && categoryMappingInputLocked)
          ? undefined
          : handleReset
      }
      onApply={categoryMappingProductMode ? undefined : handleSubmit}
      applyLabel={categoryMappingMode ? "Salva mappatura" : "Applica filtri"}
      closeLabel="Annulla"
    />
  );

  if (!visible || (!embedded && typeof document === "undefined")) {
    return null;
  }

  if (embedded) {
    return (
      <div className={`h-100 ${temaColori}`}>
        {layout}
      </div>
    );
  }

  return createPortal(
    <div
      className={`fixed top-0 left-0 right-0 bottom-0 sfondoOverlayTema flex items-center justify-center ${temaColori}`}
      style={{ zIndex: 9999 }}
      onClick={handleClose}
    >
      <div
        className="w-90 center br3 shadow-4 overflow-hidden sfondoBiancoTema"
        style={{ maxHeight: "90vh", height: "90vh", maxWidth: "1780px" }}
        onClick={(event) => event.stopPropagation()}
      >
        {layout}
      </div>
    </div>,
    document.body,
  );

}

export default withLogisticaConfiguration(ModaArticoliAdvancedFiltersModal);
